{
  "user": {
    "form": {
      "addTitle": "Tạo người dùng",
      "editTitle": "Chỉnh sửa người dùng",
      "fields": {
        "username": "Tên đăng nhập",
        "email": "Thư điện tử",
        "fullName": "Họ và tên",
        "password": "Mật khẩu",
        "confirmPassword": "Xác nhận mật khẩu",
        "facility": "Cơ sở",
        "roles": "Vai trò",
        "active": "Hoạt động",
        "allFacilities": "Tất cả cơ sở (toàn hệ thống y tế)",
        "globalAccessAck": "Tôi hiểu rằng điều này cấp quyền truy cập tới mọi cơ sở",
        "departments": "Khoa",
        "primaryDepartment": "Khoa chính",
        "roleFacility": "Cơ sở cho {{role}}",
        "grantEffective": "Effective date for {{role}} (blank = today)",
        "grantExpiration": "Expiration date for {{role}} (blank = permanent)",
        "grantProvenance": "Granted by {{name}}",
        "grantProvenanceDate": "Granted by {{name}} · {{date}}",
        "addFacilityToRole": "+ thêm cơ sở",
        "removeFacilityFromRole": "bỏ một",
        "otherRoles": "Khác"
      },
      "errors": {
        "usernameMin": "Tên đăng nhập phải có ít nhất {{min}} ký tự",
        "emailInvalid": "Địa chỉ thư điện tử không hợp lệ",
        "passwordMin": "Mật khẩu phải có ít nhất {{min}} ký tự",
        "confirmPasswordRequired": "Vui lòng xác nhận mật khẩu",
        "passwordMismatch": "Mật khẩu không khớp",
        "rolesRequired": "Phải chọn ít nhất một vai trò",
        "grantPeriodInvalid": "The grant ends before it starts",
        "globalAccessAckRequired": "Hãy xác nhận việc cấp quyền toàn hệ thống y tế trước khi lưu."
      },
      "submit": {
        "create": "Tạo người dùng",
        "update": "Cập nhật người dùng"
      },
      "cancel": "Hủy",
      "toast": {
        "createdSuccess": "Tạo người dùng thành công",
        "updatedSuccess": "Cập nhật người dùng thành công",
        "saveError": "Lưu người dùng thất bại",
        "departmentsSaveError": "Đã lưu người dùng, nhưng gán khoa thất bại. Hãy sửa người dùng để thử lại."
      },
      "globalAccessWarning": "Thao tác này cấp quyền truy cập bệnh nhân tại MỌI cơ sở, không chỉ phạm vi gọi. Chỉ dùng cho nhân viên thực sự phụ trách toàn hệ thống y tế, ví dụ nhân viên trực.",
      "departmentsHint": "Nơi tài khoản này làm việc. Chỉ dùng để ghi nhận, không cấp quyền truy cập bệnh nhân.",
      "noDepartments": "Chưa có khoa nào được cấu hình."
    },
    "list": {
      "title": "Quản lý người dùng",
      "subtitle": "Quản lý người dùng hệ thống, vai trò và quyền truy cập",
      "columns": {
        "username": "Tên đăng nhập",
        "fullName": "Họ và tên",
        "email": "Email",
        "roles": "Vai trò",
        "facility": "Cơ sở",
        "status": "Trạng thái",
        "lastLogin": "Lần đăng nhập cuối",
        "actions": "Hành động",
        "signIn": "Sign-in"
      },
      "filter": {
        "search": "Tìm người dùng...",
        "allRoles": "Tất cả vai trò",
        "allFacilities": "Tất cả cơ sở",
        "allStatus": "Tất cả trạng thái",
        "active": "Hoạt động",
        "inactive": "Không hoạt động"
      },
      "actions": {
        "new": "Tạo người dùng",
        "editTitle": "Sửa người dùng",
        "resetPasswordTitle": "Đặt lại mật khẩu",
        "activate": "Kích hoạt",
        "deactivate": "Vô hiệu hóa",
        "activateAria": "Kích hoạt người dùng",
        "deactivateAria": "Vô hiệu hóa người dùng"
      },
      "lastLoginNever": "Chưa bao giờ",
      "empty": "Không tìm thấy người dùng phù hợp với bộ lọc",
      "pagination": {
        "summary": "Hiển thị {{from}}-{{to}} trong {{total}}"
      },
      "toast": {
        "activated": "Đã kích hoạt người dùng {{username}}",
        "deactivated": "Đã vô hiệu hóa người dùng {{username}}",
        "passwordHasBeenReset": "Password for {{username}} has been reset",
        "statusFailed": "Could not update the status of {{username}}",
        "passwordFailed": "Could not reset the password"
      },
      "allFacilities": "Tất cả cơ sở",
      "deactivateConfirm": {
        "title": "Deactivate {{username}}?",
        "description": "New logins and token refreshes for {{username}} will be refused. Their roles are kept, so reactivating restores access.",
        "confirm": "Deactivate"
      },
      "resetPassword": {
        "title": "Reset password for {{username}}",
        "description": "Set a new password. It must be at least 12 characters with upper- and lowercase letters, a digit and a special character.",
        "label": "New password",
        "confirm": "Reset password"
      },
      "signIn": {
        "local": "Local",
        "sso": "SSO",
        "ldap": "Directory"
      }
    },
    "status": {
      "active": "Hoạt động",
      "inactive": "Không hoạt động",
      "locked": "Đã khóa",
      "pendingActivation": "Chờ kích hoạt"
    },
    "mfaStatus": {
      "enrolled": "Đã đăng ký",
      "notEnrolled": "Chưa đăng ký",
      "exempt": "Miễn"
    }
  },
  "role": {
    "form": {
      "addTitle": "Tạo vai trò",
      "editTitle": "Chỉnh sửa vai trò",
      "fields": {
        "name": "Tên vai trò",
        "code": "Mã vai trò",
        "description": "Mô tả",
        "category": "Danh mục",
        "parentRole": "Vai trò cha (kế thừa quyền)"
      },
      "options": {
        "none": "Không có"
      },
      "errors": {
        "nameRequired": "Tên vai trò là bắt buộc",
        "codeRequired": "Mã vai trò là bắt buộc"
      },
      "submit": {
        "create": "Tạo vai trò",
        "update": "Cập nhật vai trò"
      },
      "cancel": "Hủy",
      "toast": {
        "createdSuccess": "Tạo vai trò thành công",
        "updatedSuccess": "Cập nhật vai trò thành công",
        "saveError": "Lưu vai trò thất bại"
      }
    },
    
    "status": {
      "active": "Hoạt động",
      "inactive": "Không hoạt động"
    },
    "source": {
      "own": "Riêng",
      "inherited": "Kế thừa",
      "category": "Danh mục"
    },
    "permissions": {
      "ownTitle": "Chỉnh sửa quyền",
      "deniedTitle": "Chỉnh sửa quyền bị từ chối",
      "ownSubtitle": "Đã cấp {{granted}}/{{total}}. Quyền kế thừa và quyền mặc định theo danh mục được hiển thị trong Ma trận quyền; trang này chỉ quản lý các quyền cấp trực tiếp cho vai trò.",
      "deniedSubtitle": "Quyền bị từ chối sẽ ghi đè các quyền được cấp từ chính vai trò, vai trò cha, và mặc định danh mục. Đánh dấu một quyền để từ chối tường minh cho vai trò này.",
      "invalidRoleId": "ID vai trò không hợp lệ.",
      "save": "Lưu quyền",
      "saveDenied": "Lưu quyền bị từ chối",
      "cancel": "Hủy",
      "toast": {
        "updatedSuccess": "Đã cập nhật quyền",
        "deniedUpdatedSuccess": "Đã cập nhật quyền bị từ chối",
        "saveError": "Lưu quyền thất bại",
        "saveDeniedError": "Lưu quyền bị từ chối thất bại"
      },
      "permissionGroup": {
        "analytics": "Phân tích",
        "audit": "Kiểm toán",
        "billing": "Thanh toán",
        "bloodProduct": "Chế phẩm máu",
        "consent": "Đồng thuận",
        "dietOrder": "Y lệnh dinh dưỡng",
        "discharge": "Xuất viện",
        "documentation": "Tài liệu",
        "encounter": "Lần khám",
        "infection": "Kiểm soát nhiễm khuẩn",
        "licensing": "Cấp phép",
        "medication": "Thuốc",
        "notification": "Thông báo",
        "order": "Y lệnh",
        "patient": "Bệnh nhân",
        "referral": "Chuyển tuyến",
        "research": "Nghiên cứu",
        "restraint": "Cố định",
        "result": "Kết quả",
        "scheduling": "Lịch hẹn",
        "system": "Hệ thống",
        "transfer": "Chuyển khoa",
        "user": "Người dùng",
        "schedule": "Lịch",
        "admin": "Quản trị",
        "report": "Báo cáo",
        "other": "Khác"
      }
    }
  },
  "category": {
    "form": {
      "addTitle": "Tạo danh mục",
      "editTitle": "Sửa danh mục",
      "fields": {
        "name": "Tên danh mục",
        "code": "Mã danh mục",
        "description": "Mô tả",
        "sessionTimeout": "Hết hạn phiên (phút)",
        "maxFailedLogins": "Số lần đăng nhập thất bại tối đa",
        "mfaRequired": "Bắt buộc MFA cho danh mục này"
      },
      "placeholders": {
        "code": "ví dụ CLINICAL"
      },
      "errors": {
        "nameRequired": "Tên danh mục là bắt buộc",
        "codeRequired": "Mã danh mục là bắt buộc"
      },
      "submit": {
        "create": "Tạo danh mục",
        "update": "Cập nhật danh mục"
      },
      "cancel": "Hủy",
      "toast": {
        "createdSuccess": "Đã tạo danh mục",
        "updatedSuccess": "Đã cập nhật danh mục",
        "saveError": "Không thể lưu danh mục"
      }
    },
    "list": {},
    "auditLevel": {
      "none": "Không",
      "basic": "Cơ bản",
      "full": "Đầy đủ",
      "paranoid": "Nghiêm ngặt"
    },
    "permissions": {
      "title": "Quyền mặc định",
      "titleWithName": "Quyền mặc định — {{name}}",
      "subtitle": "Các vai trò trong danh mục này kế thừa các quyền này trừ khi từ chối tường minh.",
      "invalidCategoryId": "ID danh mục không hợp lệ.",
      "save": "Lưu quyền mặc định",
      "cancel": "Hủy",
      "toast": {
        "updatedSuccess": "Đã cập nhật quyền mặc định",
        "saveError": "Không thể lưu quyền mặc định"
      }
    }
  },
  "permission": {
    "action": {
      "view": "Xem",
      "viewSelf": "Chỉ xem bản thân",
      "viewRestricted": "Xem giới hạn",
      "read": "Đọc",
      "write": "Ghi",
      "create": "Tạo",
      "update": "Cập nhật",
      "modify": "Sửa",
      "delete": "Xóa",
      "merge": "Gộp",
      "discharge": "Xuất viện",
      "transfer": "Chuyển khoa",
      "approve": "Phê duyệt",
      "cosign": "Đồng ký",
      "sign": "Ký",
      "plan": "Lập kế hoạch",
      "manage": "Quản lý",
      "all": "Tất cả",
      "breakGlass": "Truy cập khẩn cấp",
      "export": "Xuất",
      "amend": "Sửa đổi",
      "administer": "Cấp phát",
      "doubleCheck": "Kiểm tra kép",
      "reconcile": "Đối soát thuốc",
      "verbalVerify": "Xác nhận y lệnh miệng",
      "verify": "Xác minh",
      "acknowledge": "Xác nhận",
      "prescribe": "Kê đơn",
      "dispense": "Cấp phát",
      "cancel": "Hủy",
      "users": "Người dùng",
      "roles": "Vai trò",
      "facilities": "Cơ sở",
      "system": "Hệ thống",
      "audit": "Nhật ký kiểm toán"
    }
  },
  "access": {
    "title": "Ma trận quyền truy cập",
    "subtitle": "Lưới vai trò × quyền",
    "searchPermission": "Tìm kiếm quyền…",
    "searchRole": "Tìm kiếm vai trò…",
    "categoryFilter": "Danh mục",
    "legend": {
      "own": "Sở hữu",
      "inherited": "Kế thừa",
      "category": "Danh mục",
      "denied": "Từ chối",
      "none": "Không có"
    },
    "cellTooltip": {
      "hasOwn": "Được cấp trực tiếp",
      "hasInherited": "Kế thừa từ vai trò cha: {{source}}",
      "hasCategory": "Được cấp qua danh mục: {{source}}",
      "denied": "Từ chối tường minh",
      "none": "Chưa được cấp"
    },
    "inheritedFrom": "Kế thừa từ {{source}}",
    "bulkEdit": {
      "title": "Chỉnh sửa hàng loạt",
      "applyTo": "Áp dụng cho mục đã chọn",
      "selectedPermissions": "{{count}} quyền",
      "selectedRoles": "{{count}} vai trò",
      "actionGrant": "Cấp",
      "actionDeny": "Từ chối",
      "actionClear": "Xóa",
      "save": "Lưu thay đổi",
      "cancel": "Hủy"
    },
    "emptyRoles": "Không có vai trò nào khớp với bộ lọc.",
    "emptyPermissions": "Không có quyền nào khớp với bộ lọc.",
    "loading": "Đang tải ma trận quyền truy cập…",
    "permissionColumn": "Quyền",
    "rolePicker": {
      "trigger": "Chọn vai trò để so sánh",
      "filterPlaceholder": "Lọc vai trò…",
      "empty": "Không có vai trò khớp.",
      "groupAll": "Tất cả",
      "groupNone": "Không",
      "footerSummary": "Đã chọn {{count}} / {{total}}",
      "selectAll": "Chọn tất cả",
      "clear": "Xóa"
    },
    "empty": {
      "selectRolesPrompt": "Chọn ít nhất một vai trò để so sánh.",
      "selectAllRoles": "Chọn tất cả vai trò",
      "noPermissions": "Không tìm thấy quyền."
    },
    "legendCategoryDefault": "Mặc định danh mục",
    "legendNotGranted": "Chưa được cấp",
    "page": {
      "title": "Ma trận quyền truy cập",
      "subtitle": "Xem và quản lý vai trò, quyền và chính sách truy cập"
    },
    "tabs": {
      "matrix": "Ma trận quyền truy cập",
      "roles": "Quản lý vai trò",
      "categories": "Quản lý danh mục"
    },
    "roles": {
      "searchPlaceholder": "Tìm kiếm vai trò hoặc quyền...",
      "createButton": "Tạo vai trò",
      "columns": {
        "role": "Vai trò",
        "category": "Danh mục",
        "parent": "Vai trò cha",
        "permissions": "Quyền",
        "users": "Người dùng",
        "actions": "Hành động"
      },
      "systemBadge": "Hệ thống",
      "managePermissionsTitle": "Quản lý quyền",
      "manageDeniedTitle": "Quản lý quyền bị từ chối",
      "deniedBadge": "Từ chối",
      "editTitle": "Chỉnh sửa vai trò",
      "deleteTitle": "Xóa vai trò",
      "expandAria": "Mở rộng vai trò",
      "collapseAria": "Thu gọn vai trò",
      "effectivePermissions": "Quyền hiệu lực",
      "noPermissionsAssigned": "Không có quyền nào được gán.",
      "empty": "Không tìm thấy vai trò.",
      "delete": {
        "title": "Xóa vai trò",
        "description": "Bạn có chắc chắn muốn xóa vai trò \"{{name}}\"? Hành động này không thể hoàn tác.",
        "confirm": "Xóa"
      },
      "toast": {
        "deleted": "Đã xóa vai trò",
        "deleteError": "Không thể xóa vai trò"
      }
    },
    "categories": {
      "subtitle": "Danh mục nhóm các vai trò và xác định chính sách chung (MFA, giới hạn phiên).",
      "createButton": "Tạo danh mục",
      "requireMfa": "Yêu cầu MFA",
      "yes": "Có",
      "no": "Không",
      "sessionTimeout": "Thời gian chờ phiên",
      "sessionTimeoutMinutes": "{{count}} phút",
      "maxFailedLogins": "Số lần đăng nhập thất bại tối đa",
      "manageDefaults": "Quản lý quyền mặc định",
      "editTitle": "Chỉnh sửa",
      "editAria": "Chỉnh sửa danh mục",
      "deleteTitle": "Xóa",
      "deleteAria": "Xóa danh mục",
      "empty": "Chưa có danh mục nào được định nghĩa.",
      "delete": {
        "title": "Xóa danh mục",
        "description": "Bạn có chắc chắn muốn xóa danh mục \"{{name}}\"? Hành động này không thể hoàn tác.",
        "confirm": "Xóa"
      },
      "toast": {
        "deleted": "Đã xóa danh mục",
        "deleteError": "Không thể xóa danh mục"
      }
    },
    "confirm": {
      "bulkApply": "Áp dụng {{count}} thay đổi cho {{roleCount}} vai trò?",
      "discardChanges": "Hủy bỏ các thay đổi chưa lưu?"
    },
    "popover": {
      "grantTitle": "Cấp quyền",
      "denyTitle": "Từ chối quyền",
      "clearTitle": "Xóa quyền",
      "grantNote": "Cấp quyền này sẽ ghi đè mọi cài đặt từ chối được kế thừa.",
      "denyNote": "Từ chối quyền này sẽ ghi đè mọi cài đặt cấp được kế thừa.",
      "clearNote": "Xóa sẽ khôi phục về hành vi kế thừa."
    },
    "toast": {
      "permissionGranted": "Đã cấp quyền",
      "permissionDenied": "Đã từ chối quyền",
      "permissionCleared": "Đã xóa quyền",
      "bulkApplied": "Đã áp dụng các thay đổi hàng loạt",
      "saveError": "Không thể lưu thay đổi"
    }
  },
  "confirm": {
    "restartIntegration": "Khởi động lại \"{{name}}\"? Các kết nối đang hoạt động sẽ bị ngắt trong giây lát khi tải vật liệu TLS mới.",
    "revokeFhirEndpoint": "Thu hồi \"{{name}}\"? Các lệnh gọi đi đến điểm cuối này sẽ dừng lại.",
    "rotateSmartSecret": "Xoay vòng client secret cho \"{{name}}\"? Secret cũ sẽ ngừng hoạt động ngay lập tức.",
    "revokeSmartApp": "Thu hồi \"{{name}}\"? Các yêu cầu token trong tương lai từ ứng dụng này sẽ thất bại.",
    "deactivateThirdPartyApp": "Vô hiệu hóa \"{{name}}\"?"
  },
  "toast": {
    "tierCreated": "Đã tạo bậc",
    "tierCloned": "Đã sao chép bậc",
    "tierDeleted": "Đã xóa bậc",
    "tierStatusUpdated": "Đã cập nhật trạng thái",
    "tierFeaturesUpdated": "Đã cập nhật tính năng",
    "tierLimitsUpdated": "Đã cập nhật giới hạn",
    "tierSaveError": "Tạo bậc thất bại",
    "tierValidation": "Tên và mã là bắt buộc",
    "licenseKeyGenerated": "Đã tạo khóa giấy phép",
    "licenseKeyCopied": "Đã tạo khóa giấy phép và sao chép vào bộ nhớ tạm",
    "overridesSaved": "Đã lưu ghi đè",
    "pricingConfigSaved": "Đã lưu cấu hình",
    "pricingPriceUpdated": "Đã cập nhật giá",
    "pricingRuleCreated": "Đã tạo quy tắc định giá",
    "addonUpdated": "Đã cập nhật mô-đun bổ sung",
    "invalidNumber": "Vui lòng nhập một số hợp lệ",
    "csvExported": "Đã xuất {{filename}}",
    "integrationUpdated": "Đã cập nhật tích hợp",
    "integrationAdded": "Đã thêm tích hợp",
    "integrationInvalidConfig": "Cấu hình không hợp lệ — kiểm tra máy chủ/cổng và các trường TLS",
    "integrationDuplicateName": "Đã tồn tại một tích hợp trùng tên",
    "integrationSaveFailed": "Lưu tích hợp thất bại",
    "smartAppRegistered": "Đã đăng ký ứng dụng SMART",
    "smartAppRegisterFailed": "Đăng ký ứng dụng SMART thất bại",
    "smartAppUpdated": "Đã cập nhật ứng dụng SMART",
    "smartAppUpdateFailed": "Cập nhật ứng dụng SMART thất bại",
    "fhirEndpointUpdated": "Đã cập nhật endpoint",
    "fhirEndpointRegistered": "Đã đăng ký endpoint",
    "fhirEndpointInvalidConfig": "Cấu hình không hợp lệ — kiểm tra base URL và các trường auth",
    "fhirEndpointDuplicateName": "Đã tồn tại endpoint trùng tên",
    "fhirEndpointSaveFailed": "Lưu endpoint thất bại",
    "clientIdCopied": "Đã sao chép Client ID",
    "clientSecretCopied": "Đã sao chép client secret",
    "statusRefreshed": "Đã làm mới trạng thái",
    "connTestOk": "Kiểm tra kết nối thành công",
    "connTestFailed": "Kiểm tra kết nối thất bại - kiểm tra cấu hình endpoint",
    "serverRestarted": "Đã khởi động lại máy chủ — vật liệu TLS mới có hiệu lực",
    "clientReconnected": "Máy khách đã kết nối lại — vật liệu TLS mới có hiệu lực",
    "notRunning": "Không chạy — khởi động máy chủ/máy khách để áp dụng cấu hình",
    "restartFailed": "Khởi động lại tích hợp thất bại",
    "metadataOk": "/metadata OK{{detail}}",
    "metadataFailed": "/metadata thất bại: {{error}}",
    "metadataProbeFailed": "Không thể thăm dò /metadata",
    "metadataUnknownError": "không xác định",
    "fhirRevoked": "Đã thu hồi endpoint FHIR",
    "fhirRevokeFailed": "Không thể thu hồi endpoint",
    "smartRevoked": "Đã thu hồi ứng dụng SMART",
    "smartRevokeFailed": "Không thể thu hồi ứng dụng SMART",
    "secretRotated": "Đã xoay vòng bí mật máy khách",
    "rotateSecretFailed": "Không thể xoay vòng bí mật",
    "messageRequeued": "Đã đưa tin nhắn vào hàng đợi để thử lại",
    "messageRetryFailed": "Thử lại thất bại",
    "messageSkipped": "Đã bỏ qua tin nhắn — hàng đợi sẽ tiếp tục",
    "messageSkipFailed": "Bỏ qua thất bại",
    "messageAbandoned": "Đã hủy bỏ tin nhắn",
    "messageAbandonFailed": "Hủy bỏ thất bại",
    "messageResent": "Đã gửi lại tin nhắn như mới",
    "messageResendFailed": "Gửi lại thất bại",
    "reasonRequired": "Cần có lý do",
    "copiedToClipboard": "Đã sao chép vào bảng nhớ tạm",
    "thirdPartyAppCreated": "Đã tạo ứng dụng bên thứ ba thành công",
    "thirdPartyAppUpdated": "Đã cập nhật ứng dụng bên thứ ba thành công",
    "thirdPartyAppDeactivated": "Đã vô hiệu hóa ứng dụng bên thứ ba",
    "thirdPartyAppLaunchUrl": "Đã tạo URL khởi chạy: {{url}}"
  },
  "facility": {
    "form": {
      "addTitle": "Thêm cơ sở",
      "editTitle": "Chỉnh sửa cơ sở",
      "fields": {
        "name": "Tên",
        "code": "Mã",
        "type": "Loại",
        "address": "Địa chỉ",
        "city": "Thành phố",
        "stateProvince": "Tỉnh/Bang",
        "country": "Quốc gia",
        "phone": "Điện thoại",
        "timeZone": "Múi giờ",
        "healthSystem": "Health System",
        "visibilityScope": "Patient visibility override",
        "visibilityScopeDesc": "Narrow or widen patient visibility for this facility. The stricter side always wins between the user's and the patient's facility. Takes effect immediately.",
        "visibilityInherit": "Inherit global default"
      },
      "placeholders": {
        "timeZone": "Ví dụ: Asia/Bangkok",
        "healthSystem": "Select a health system"
      },
      "helper": {
        "timeZone": "Tên múi giờ IANA (ví dụ: Asia/Singapore). Được dùng cho ngày địa phương của cơ sở trong thống kê bệnh nhân, MAR và báo cáo."
      },
      "options": {
        "otherIana": "Khác (IANA)…",
        "useCuratedList": "Sử dụng danh sách gợi ý"
      },
      "errors": {
        "nameMin": "Tên cơ sở phải có ít nhất {{min}} ký tự",
        "codeFormat": "Mã chỉ được chứa chữ in hoa và số",
        "typeRequired": "Loại cơ sở là bắt buộc",
        "countryRequired": "Quốc gia là bắt buộc",
        "timeZoneRequired": "Múi giờ là bắt buộc",
        "timeZoneInvalidIana": "Máy chủ đã từ chối múi giờ này. Vui lòng sử dụng tên IANA hợp lệ (ví dụ: Asia/Singapore).",
        "healthSystemRequired": "Health system is required"
      },
      "submit": {
        "create": "Tạo",
        "update": "Cập nhật"
      },
      "cancel": "Hủy",
      "toast": {
        "createdSuccess": "Tạo cơ sở thành công",
        "updatedSuccess": "Cập nhật cơ sở thành công",
        "saveError": "Lưu cơ sở thất bại",
        "invalidTimeZone": "Yêu cầu không hợp lệ — vui lòng kiểm tra múi giờ có phải là tên IANA hợp lệ (ví dụ: Asia/Singapore)."
      },
      "memberships": {
        "title": "Group Memberships",
        "columns": {
          "group": "Group",
          "role": "Role",
          "effective": "Effective",
          "end": "End",
          "status": "Status",
          "actions": "Actions"
        },
        "add": {
          "healthSystem": "Health system",
          "role": "Role",
          "effective": "Effective date",
          "end": "End date (optional)",
          "submit": "Add membership"
        },
        "roles": {
          "primary": "Primary",
          "member": "Member",
          "partner": "Partner"
        },
        "endMembership": "End membership",
        "toast": {
          "createdSuccess": "Membership added",
          "updatedSuccess": "Membership updated",
          "endedSuccess": "Membership ended",
          "saveError": "Failed to save membership",
          "conflict": "An open membership for this facility and group already exists"
        }
      },
      "__review_healthSystem": "EN placeholder — needs translation"
    },
    "list": {
      "title": "Quản lý cơ sở",
      "subtitle": "Cơ sở, khoa, và (qua cây này) tổng quan về phân cấp vị trí vật lý. Để xem cây vị trí đầy đủ (tòa nhà → tầng → đơn vị → phòng → giường), xem <locationsLink>Vị trí</locationsLink>.",
      "columns": {
        "name": "Tên",
        "code": "Mã",
        "type": "Loại",
        "address": "Địa chỉ",
        "phone": "Điện thoại",
        "depts": "Khoa",
        "status": "Trạng thái",
        "actions": "Thao tác"
      },
      "filter": {
        "search": "Tìm cơ sở..."
      },
      "actions": {
        "new": "Thêm cơ sở",
        "editTitle": "Chỉnh sửa"
      },
      "expand": {
        "expand": "Mở rộng cơ sở",
        "collapse": "Thu gọn cơ sở"
      },
      "empty": {
        "noMatch": "Không có cơ sở nào phù hợp với tìm kiếm đó.",
        "none": "Chưa có cơ sở nào — nhấp Thêm cơ sở để bắt đầu."
      },
      "departments": {
        "title": "Khoa",
        "add": "Thêm khoa",
        "empty": "Chưa cấu hình khoa nào",
        "locationsCount": "{{count}} vị trí",
        "editTitle": "Chỉnh sửa khoa"
      },
      "locations": {
        "title": "Vị trí",
        "add": "Thêm",
        "empty": "Không có vị trí nào trong khoa này. Cây vị trí (tòa nhà → tầng → đơn vị → giường) được quản lý trong <locationsLink>Vị trí</locationsLink>."
      }
    },
    "type": {
      "generalHospital": "Bệnh viện đa khoa",
      "teachingHospital": "Bệnh viện đào tạo",
      "specialtyHospital": "Bệnh viện chuyên khoa",
      "communityHospital": "Bệnh viện cộng đồng",
      "clinic": "Phòng khám"
    },
    "status": {
      "active": "Hoạt động",
      "inactive": "Không hoạt động"
    }
  },
  "healthSystem": {
    "form": {
      "addTitle": "Thêm hệ thống y tế",
      "editTitle": "Chỉnh sửa hệ thống y tế",
      "subtitle": "Cấp cao nhất trong cơ cấu tổ chức. Đơn vị cha của một hoặc nhiều cơ sở y tế.",
      "sections": {
        "identity": "Thông tin định danh",
        "primaryContact": "Liên hệ chính",
        "address": "Địa chỉ"
      },
      "fields": {
        "code": "Mã",
        "name": "Tên",
        "taxId": "Mã số thuế",
        "contactName": "Họ và tên",
        "contactEmail": "Email",
        "contactPhone": "Điện thoại",
        "addressLine1": "Địa chỉ dòng 1",
        "addressLine2": "Địa chỉ dòng 2",
        "city": "Thành phố",
        "stateProvince": "Tỉnh/Bang",
        "postalCode": "Mã bưu chính",
        "country": "Quốc gia",
        "active": "Đang hoạt động — bỏ chọn để vô hiệu hóa."
      },
      "placeholders": {
        "code": "VYNAEMR-SG",
        "name": "VynaEMR Singapore",
        "taxId": "UEN / Tax ID",
        "country": "SG"
      },
      "helper": {
        "codeImmutable": "Mã không thể thay đổi sau khi tạo."
      },
      "errors": {
        "codeRequired": "Vui lòng nhập mã",
        "nameRequired": "Vui lòng nhập tên"
      },
      "submit": {
        "create": "Tạo hệ thống y tế",
        "update": "Lưu thay đổi"
      },
      "cancel": "Hủy",
      "toast": {
        "createdSuccess": "Đã tạo hệ thống y tế",
        "updatedSuccess": "Đã cập nhật hệ thống y tế",
        "saveError": "Không thể lưu hệ thống y tế",
        "codeConflict": "Mã hệ thống đã tồn tại",
        "invalidData": "Dữ liệu hệ thống y tế không hợp lệ"
      }
    },
    "list": {
      "title": "Hệ thống y tế",
      "subtitle": "Cấp cao nhất của cây tổ chức — các đơn vị mẹ kiểu doanh nghiệp / hệ thống y tế sở hữu một hoặc nhiều cơ sở. Hiếm khi thay đổi sau khi thiết lập ban đầu.",
      "columns": {
        "name": "Tên",
        "code": "Mã",
        "contact": "Liên hệ",
        "location": "Vị trí",
        "facilities": "Cơ sở",
        "status": "Trạng thái",
        "actions": "Thao tác"
      },
      "filter": {
        "search": "Tìm theo tên hoặc mã..."
      },
      "actions": {
        "new": "Thêm hệ thống y tế",
        "editTitle": "Chỉnh sửa"
      },
      "status": {
        "active": "Hoạt động",
        "inactive": "Không hoạt động"
      },
      "empty": {
        "noMatch": "Không có hệ thống y tế nào phù hợp với tìm kiếm đó.",
        "none": "Chưa có hệ thống y tế nào — nhấp Thêm hệ thống y tế để bắt đầu."
      }
    }
  },
  "location": {
    "form": {
      "addTitle": "Thêm vị trí",
      "editTitle": "Sửa vị trí",
      "subtitle": "Vị trí vật lý — tòa nhà, tầng, đơn vị, phòng hoặc giường. Tương thích FHIR R4 Location. Lồng qua vị trí cha để xây dựng cây phân cấp.",
      "sections": {
        "hierarchy": "Phân cấp",
        "identity": "Định danh",
        "classification": "Phân loại",
        "physicalAttributes": "Thuộc tính vật lý"
      },
      "fields": {
        "facility": "Cơ sở",
        "parentLocation": "Vị trí cha",
        "department": "Khoa (tùy chọn)",
        "code": "Mã",
        "abbreviation": "Viết tắt",
        "name": "Tên",
        "physicalType": "Loại vật lý (FHIR)",
        "clinicalType": "Loại lâm sàng",
        "status": "Trạng thái (FHIR)",
        "operationalStatus": "Trạng thái vận hành (HL7 0116)",
        "building": "Tòa nhà",
        "floor": "Tầng",
        "wing": "Cánh",
        "roomNumber": "Số phòng",
        "bedIdentifier": "Mã giường",
        "capacity": "Sức chứa",
        "active": "Hoạt động (cờ cũ)"
      },
      "placeholders": {
        "facility": "Chọn cơ sở…",
        "parentNone": "Không (cấp cao nhất)",
        "departmentNone": "Không",
        "code": "4W-12-A",
        "name": "4W-12 Giường A",
        "building": "A",
        "floor": "4",
        "wing": "West",
        "roomNumber": "4W-12",
        "bedIdentifier": "A"
      },
      "helper": {
        "physicalType": "Bộ giá trị FHIR LocationPhysicalType.",
        "clinicalType": "Cũ; loại bỏ khi service_type ra mắt."
      },
      "physicalAttributes": {
        "show": "Hiển thị ▾",
        "hide": "Ẩn ▴"
      },
      "errors": {
        "facilityRequired": "Vui lòng chọn cơ sở",
        "codeRequired": "Vui lòng nhập mã",
        "nameRequired": "Vui lòng nhập tên"
      },
      "submit": {
        "create": "Tạo vị trí",
        "update": "Lưu thay đổi"
      },
      "cancel": "Hủy",
      "toast": {
        "createdSuccess": "Đã tạo vị trí",
        "updatedSuccess": "Đã cập nhật vị trí",
        "saveError": "Không thể lưu vị trí",
        "codeConflict": "Mã vị trí đã tồn tại",
        "invalidData": "Dữ liệu vị trí không hợp lệ"
      }
    },
    "list": {
      "title": "Phân cấp vị trí",
      "subtitle": "Cây vật lý: tòa nhà → tầng → đơn vị → phòng → giường. Tuân theo FHIR LocationPhysicalType. Nhấp vào huy hiệu trạng thái giường để luân chuyển tình trạng sử dụng. Cơ sở và khoa được quản lý trong <facilitiesLink>Cơ sở</facilitiesLink>.",
      "filter": {
        "search": "Tìm theo tên hoặc mã...",
        "allFacilities": "Tất cả cơ sở"
      },
      "actions": {
        "new": "Thêm vị trí",
        "addChildTitle": "Thêm vị trí con",
        "editTitle": "Sửa"
      },
      "expand": {
        "expand": "Mở rộng vị trí",
        "collapse": "Thu gọn vị trí"
      },
      "bed": {
        "toggleTitle": "Nhấp để chuyển sang {{next}}"
      },
      "empty": {
        "noMatch": "Không có vị trí nào khớp với tìm kiếm đó.",
        "none": "Cơ sở này chưa có vị trí nào."
      },
      "toast": {
        "bedStatusUpdated": "Đã cập nhật trạng thái giường",
        "bedStatusError": "Cập nhật trạng thái giường thất bại"
      }
    },
    "type": {
      "si": "Khuôn viên",
      "bu": "Tòa nhà",
      "wi": "Cánh",
      "wa": "Khu điều trị",
      "lvl": "Tầng",
      "co": "Hành lang",
      "ro": "Phòng",
      "bd": "Giường",
      "ve": "Ảo",
      "ho": "Nhà",
      "ca": "Tủ",
      "rd": "Đường",
      "area": "Khu vực",
      "jdn": "Khu hành chính"
    },
    "clinicalType": {
      "examRoom": "Phòng khám",
      "inpatientBed": "Giường nội trú",
      "procedureRoom": "Phòng thủ thuật",
      "icu": "ICU",
      "ed": "Cấp cứu",
      "or": "Phòng mổ",
      "virtual": "Ảo"
    },
    "status": {
      "active": "Đang hoạt động",
      "suspended": "Tạm ngưng",
      "inactive": "Ngừng hoạt động",
      "op": {
        "O": "Đã sử dụng",
        "U": "Trống",
        "H": "Đang dọn dẹp",
        "K": "Bị nhiễm",
        "I": "Cách ly",
        "C": "Đã đóng"
      }
    },
    "capability": {
      "isolation": "Có thể cách ly",
      "negativePressure": "Áp suất âm",
      "bariatric": "Hỗ trợ béo phì",
      "telemetry": "Hỗ trợ đo từ xa",
      "icu": "Cấp ICU"
    }
  },
  "department": {
    "form": {
      "addTitle": "Thêm khoa",
      "editTitle": "Chỉnh sửa khoa",
      "subtitle": "Đơn vị tổ chức trong cơ sở. Có thể lồng nhau (ví dụ: Tim mạch → Phòng EP) thông qua khoa cha.",
      "sections": {
        "department": "Khoa"
      },
      "fields": {
        "facility": "Cơ sở",
        "code": "Mã",
        "abbreviation": "Viết tắt",
        "name": "Tên",
        "type": "Loại",
        "parentDepartment": "Khoa cha",
        "costCenterCode": "Mã trung tâm chi phí",
        "revenueDepartmentCode": "Mã khoa doanh thu",
        "active": "Hoạt động — bỏ chọn để vô hiệu hóa mềm."
      },
      "placeholders": {
        "facility": "Chọn cơ sở…",
        "code": "CARDIO",
        "abbreviation": "CARD",
        "name": "Tim mạch",
        "parentNone": "Không (cấp cao nhất)",
        "typeNone": "—",
        "costCenterCode": "CC-CARDIO",
        "revenueDepartmentCode": "RD-410"
      },
      "errors": {
        "facilityRequired": "Cơ sở là bắt buộc",
        "codeRequired": "Mã là bắt buộc",
        "nameRequired": "Tên là bắt buộc"
      },
      "submit": {
        "create": "Tạo khoa",
        "update": "Lưu thay đổi"
      },
      "cancel": "Hủy",
      "toast": {
        "createdSuccess": "Tạo khoa thành công",
        "updatedSuccess": "Cập nhật khoa thành công",
        "saveError": "Lưu khoa thất bại",
        "codeConflict": "Mã khoa đã tồn tại",
        "invalidData": "Dữ liệu khoa không hợp lệ"
      }
    },
    "serviceType": {
      "clinical": "Lâm sàng",
      "administrative": "Hành chính",
      "support": "Hỗ trợ"
    },
    "status": {
      "active": "Hoạt động",
      "inactive": "Không hoạt động"
    }
  },
  "provider": {
    "form": {
      "addTitle": "Thêm Bác sĩ",
      "editTitle": "Chỉnh sửa Bác sĩ",
      "fields": {
        "fullName": "Họ và Tên",
        "npi": "NPI",
        "providerType": "Loại nhân viên y tế",
        "credentials": "Chứng chỉ",
        "specialty": "Chuyên khoa",
        "email": "Email",
        "phone": "Điện thoại",
        "facilityAssignments": "Phân công Cơ sở",
        "status": "Trạng thái",
        "primaryFacility": "Cơ sở chính",
        "loginAccount": "Tài khoản đăng nhập"
      },
      "placeholders": {
        "specialty": "Chọn chuyên khoa…",
        "credentials": "vd. MD, FACC",
        "providerType": "Chọn loại nhân viên y tế",
        "noLoginAccount": "Không có tài khoản đăng nhập"
      },
      "submit": {
        "create": "Tạo",
        "update": "Cập nhật"
      },
      "cancel": "Hủy",
      "toast": {
        "createdSuccess": "Đã tạo bác sĩ",
        "updatedSuccess": "Đã cập nhật bác sĩ",
        "saveError": "Không thể lưu bác sĩ"
      },
      "hints": {
        "loginAccount": "Liên kết nhân viên lâm sàng này với tài khoản họ dùng để đăng nhập. Nếu không, việc đồng ký, dược sĩ xác minh và xác nhận kết quả nguy cấp đều sẽ bị từ chối."
      }
    },
    "list": {
      "title": "Quản lý Nhà cung cấp",
      "subtitle": "Quản lý nhà cung cấp, chứng chỉ và phân công cơ sở",
      "columns": {
        "name": "Họ và tên",
        "npi": "NPI",
        "specialty": "Chuyên khoa",
        "credentials": "Chứng chỉ",
        "facilities": "Cơ sở",
        "status": "Trạng thái",
        "actions": "Thao tác"
      },
      "filter": {
        "search": "Tìm theo tên, NPI, chuyên khoa...",
        "allSpecialties": "Tất cả chuyên khoa",
        "allFacilities": "Tất cả cơ sở",
        "allStatus": "Tất cả trạng thái"
      },
      "actions": {
        "new": "Thêm nhà cung cấp",
        "editTitle": "Sửa nhà cung cấp",
        "scheduleTitle": "Mẫu lịch trình",
        "viewCredentials": "Xem chứng chỉ"
      },
      "credentials": {
        "licenseLabel": "Giấy phép",
        "none": "Không có chứng chỉ nào trong hồ sơ"
      },
      "empty": "Không tìm thấy nhà cung cấp",
      "pagination": {
        "summary": "{{from}}-{{to}} trên {{total}}",
        "pageOf": "{{page}}/{{totalPages}}",
        "previous": "Trang trước",
        "next": "Trang sau"
      },
      "toast": {
        "schedulePlaceholder": "Liên kết mẫu lịch trình (chỗ giữ chỗ)"
      },
      "noLogin": "Chưa có đăng nhập",
      "noLoginHint": "Nhân viên này chưa liên kết tài khoản đăng nhập nên không thể đồng ký, xác minh hoặc xác nhận."
    },
    "specialty": {
      "internalMedicine": "Nội Khoa",
      "cardiology": "Tim Mạch",
      "emergencyMedicine": "Cấp Cứu",
      "pediatrics": "Nhi Khoa",
      "pathology": "Giải Phẫu Bệnh",
      "obstetricsGynecology": "Sản Phụ Khoa",
      "surgery": "Ngoại Khoa",
      "orthopedics": "Chấn Thương Chỉnh Hình",
      "neurology": "Thần Kinh",
      "psychiatry": "Tâm Thần",
      "radiology": "Chẩn Đoán Hình Ảnh",
      "anesthesiology": "Gây Mê Hồi Sức",
      "oncology": "Ung Bướu",
      "dermatology": "Da Liễu",
      "ophthalmology": "Mắt"
    },
    "status": {
      "active": "Đang làm việc",
      "inactive": "Không hoạt động",
      "onLeave": "Nghỉ phép"
    },
    "providerType": {
      "physician": "Bác sĩ",
      "nurse": "Điều dưỡng",
      "nursePractitioner": "Điều dưỡng chuyên khoa",
      "physicianAssistant": "Trợ lý bác sĩ",
      "pharmacist": "Dược sĩ",
      "therapist": "Nhà trị liệu",
      "technician": "Kỹ thuật viên",
      "other": "Khác",
      "midwife": "Hộ sinh",
      "dentist": "Nha sĩ",
      "pharmacyTechnician": "Kỹ thuật viên dược",
      "careAssistant": "Trợ lý điều dưỡng",
      "dietitian": "Chuyên gia dinh dưỡng",
      "socialWorker": "Nhân viên công tác xã hội",
      "traditionalMedicine": "Thầy thuốc y học cổ truyền"
    }
  },
  "serviceLine": {
    "form": {
      "addTitle": "Thêm Tuyến Dịch Vụ",
      "editTitle": "Chỉnh sửa Tuyến Dịch Vụ",
      "subtitle": "Nhóm lâm sàng cấp cao (Tim mạch, Ung bướu) bao trùm các dịch vụ lâm sàng cụ thể.",
      "sections": {
        "serviceLine": "Tuyến Dịch Vụ"
      },
      "fields": {
        "healthSystem": "Hệ thống Y tế",
        "code": "Mã",
        "name": "Tên",
        "description": "Mô tả",
        "active": "Đang hoạt động — bỏ chọn để vô hiệu hóa mềm."
      },
      "placeholders": {
        "healthSystem": "Chọn hệ thống y tế…",
        "code": "CV",
        "name": "Cardiovascular",
        "description": "Mô tả ngắn — phạm vi, trọng tâm bệnh lý, v.v."
      },
      "errors": {
        "healthSystemRequired": "Cần có hệ thống y tế",
        "codeRequired": "Cần có mã",
        "nameRequired": "Cần có tên"
      },
      "submit": {
        "create": "Tạo Tuyến Dịch Vụ",
        "update": "Lưu Thay đổi"
      },
      "cancel": "Hủy",
      "toast": {
        "createdSuccess": "Đã tạo tuyến dịch vụ",
        "updatedSuccess": "Đã cập nhật tuyến dịch vụ",
        "saveError": "Lưu tuyến dịch vụ không thành công",
        "codeConflict": "Mã tuyến dịch vụ đã tồn tại",
        "invalidData": "Dữ liệu tuyến dịch vụ không hợp lệ"
      }
    },
    "category": {}
  },
  "clinicalService": {
    "form": {
      "addTitle": "Thêm Dịch vụ Lâm sàng",
      "editTitle": "Chỉnh sửa Dịch vụ Lâm sàng",
      "subtitle": "Dịch vụ lâm sàng cụ thể (Tim mạch, Phòng EP). Có thể nhóm dưới một tuyến dịch vụ + gắn mã chuyên khoa NUCC cho mục đích thanh toán + xuất danh bạ.",
      "sections": {
        "clinicalService": "Dịch vụ Lâm sàng",
        "specialtyBilling": "Chuyên khoa + Thanh toán"
      },
      "fields": {
        "code": "Mã",
        "name": "Tên",
        "serviceLine": "Tuyến Dịch Vụ",
        "description": "Mô tả",
        "specialtyCode": "Mã chuyên khoa NUCC",
        "specialtyDescription": "Mô tả chuyên khoa",
        "revenueDepartmentCode": "Mã bộ phận doanh thu",
        "active": "Đang hoạt động"
      },
      "placeholders": {
        "code": "CARDIO-EP",
        "name": "Electrophysiology",
        "serviceLineNone": "— không có —",
        "specialtyCode": "207RE0101X",
        "specialtyDescription": "Clinical Cardiac Electrophysiology",
        "revenueDepartmentCode": "RD-480"
      },
      "helper": {
        "specialtyCode": "Phân loại NUCC — định hướng danh bạ nhà cung cấp + cách thể hiện hóa đơn thanh toán."
      },
      "errors": {
        "codeRequired": "Cần có mã",
        "nameRequired": "Cần có tên"
      },
      "submit": {
        "create": "Tạo Dịch vụ Lâm sàng",
        "update": "Lưu Thay đổi"
      },
      "cancel": "Hủy",
      "toast": {
        "createdSuccess": "Đã tạo dịch vụ lâm sàng",
        "updatedSuccess": "Đã cập nhật dịch vụ lâm sàng",
        "saveError": "Lưu dịch vụ lâm sàng không thành công",
        "codeConflict": "Mã dịch vụ lâm sàng đã tồn tại",
        "invalidData": "Dữ liệu dịch vụ lâm sàng không hợp lệ"
      }
    },
    "flag": {}
  },
  "serviceLocation": {
    "title": "Phân công Dịch vụ ↔ Địa điểm",
    "subtitle": "Dịch vụ lâm sàng nào hoạt động tại địa điểm vật lý nào, với khung ngày/giờ và sức chứa tùy chọn. Lập lịch đọc các dữ liệu này để tạo các khung giờ trống. Chỉ xóa mềm — kết thúc một phân công vẫn giữ lại lịch sử cho báo cáo.",
    "header": {
      "newAssignment": "Phân công Mới",
      "toggleCancel": "Hủy"
    },
    "form": {
      "title": "Phân công mới",
      "fields": {
        "service": "Dịch vụ Lâm sàng",
        "location": "Địa điểm",
        "dayOfWeekPattern": "Mẫu ngày trong tuần",
        "startTime": "Giờ bắt đầu",
        "endTime": "Giờ kết thúc",
        "capacity": "Sức chứa %",
        "notes": "Ghi chú",
        "isPrimary": "Địa điểm chính cho dịch vụ này"
      },
      "placeholders": {
        "service": "Chọn dịch vụ…",
        "location": "Chọn địa điểm…",
        "dayOfWeekPattern": "1,3,5 (T2/T4/T6)",
        "capacity": "0–100"
      },
      "helper": {
        "dayOfWeekPattern": "Ngày ISO phân tách bằng dấu phẩy; để trống = mỗi ngày."
      },
      "errors": {
        "serviceLocationRequired": "Cần có Dịch vụ + Địa điểm"
      },
      "create": "Tạo",
      "cancel": "Hủy"
    },
    "filter": {
      "allFacilities": "Tất cả cơ sở",
      "allServices": "Tất cả dịch vụ",
      "allLocations": "Tất cả địa điểm",
      "allStatuses": "Tất cả trạng thái",
      "searchService": "Tìm dịch vụ…",
      "searchLocation": "Tìm địa điểm…",
      "facility": "Cơ sở",
      "serviceLine": "Tuyến dịch vụ"
    },
    "columns": {
      "service": "Dịch vụ",
      "location": "Địa điểm",
      "facility": "Cơ sở",
      "when": "Khi nào",
      "capacity": "Sức chứa",
      "effective": "Hiệu lực",
      "status": "Trạng thái",
      "actions": "Thao tác"
    },
    "status": {
      "active": "Đang hoạt động",
      "planned": "Đã lên kế hoạch",
      "suspended": "Tạm ngưng",
      "ended": "Đã kết thúc"
    },
    "dow": {
      "everyDay": "Mỗi ngày",
      "monFri": "T2–T6",
      "short": {
        "1": "T2",
        "2": "T3",
        "3": "T4",
        "4": "T5",
        "5": "T6",
        "6": "T7",
        "7": "CN"
      }
    },
    "cell": {
      "none": "—",
      "primaryAria": "Địa điểm chính",
      "effectiveEndPrefix": "→ {{date}}"
    },
    "actions": {
      "setPrimary": "Đặt làm chính",
      "unsetPrimary": "Bỏ đặt chính",
      "endAssignment": "Kết thúc phân công"
    },
    "bulkEdit": {
      "title": "Chỉnh sửa Hàng loạt",
      "applyTo": "Áp dụng cho mục đã chọn",
      "selectedServices": "{{count}} dịch vụ",
      "selectedLocations": "{{count}} địa điểm",
      "save": "Lưu thay đổi",
      "cancel": "Hủy"
    },
    "confirm": {
      "endTitle": "Kết thúc phân công?",
      "endDescription": "{{service}} → {{location}}. Kết thúc vẫn giữ lịch sử nhưng loại cặp này khỏi lập lịch đang hoạt động.",
      "endConfirm": "Kết thúc phân công",
      "removeService": "Gỡ {{service}} khỏi {{location}}?",
      "makePrimary": "Đặt {{location}} làm địa điểm chính cho {{service}}?"
    },
    "toast": {
      "created": "Đã tạo phân công",
      "createError": "Không tạo được phân công",
      "ended": "Đã kết thúc phân công",
      "endError": "Không kết thúc được phân công",
      "primaryError": "Không chuyển đổi được chính",
      "updated": "Đã cập nhật phân công"
    },
    "empty": "Không có phân công nào khớp với các bộ lọc này. Nhấp Phân công Mới để thêm."
  },
  "integration": {
    "list": {
      "title": "Quản lý Tích hợp",
      "subtitle": "Tích hợp hệ thống HL7, FHIR và bên thứ ba",
      "refresh": "Làm mới",
      "addEndpoint": "Thêm Endpoint",
      "searchPlaceholder": "Tìm kiếm tích hợp…",
      "tabs": {
        "endpoints": "Endpoint",
        "messageLog": "Nhật ký Tin nhắn",
        "fhirSmart": "FHIR / SMART"
      },
      "cards": {
        "totalEndpoints": "Tổng số Endpoint",
        "connected": "Đã kết nối",
        "errors": "Lỗi",
        "totalMessages": "Tổng số Tin nhắn"
      }
    },
    "columns": {
      "status": "Trạng thái",
      "name": "Tên",
      "type": "Loại",
      "direction": "Hướng",
      "url": "URL",
      "tls": "TLS",
      "auth": "Xác thực",
      "lastMessage": "Tin nhắn Cuối",
      "messages": "Tin nhắn",
      "errors": "Lỗi",
      "backlog": "Tồn đọng",
      "health": "Tình trạng",
      "actions": "Thao tác",
      "backlogTitle": "Tin nhắn gửi đi đang chờ + tuổi chờ lâu nhất",
      "healthTitle": "Trạng thái tình trạng — màu đỏ nếu hàng đợi bị chặn bởi tin nhắn lỗi"
    },
    "badge": {
      "tlsCerts": "chứng chỉ: {{cert}}, khóa: {{key}}, CA: {{ca}}",
      "yes": "có",
      "no": "không",
      "basicTitle": "basic ({{username}})",
      "bearerStored": "Đã lưu mã thông báo Bearer",
      "bearerNoToken": "bearer (chưa đặt mã thông báo)",
      "mtlsCert": "Chứng chỉ máy khách mTLS",
      "awaitingAck": "{{n}} đang chờ ACK",
      "oldest": "cũ nhất {{age}}",
      "never": "Chưa bao giờ",
      "blocked": "BỊ CHẶN",
      "waiting": "ĐANG CHỜ",
      "ok": "OK",
      "blockedTitle": "Một tin nhắn lỗi đang chặn hàng đợi của tích hợp này. Nhấp để mở nhật ký đã lọc.",
      "waitingTitle": "Tin nhắn đang chờ ACK ứng dụng chế độ nâng cao từ đối tác. Nhấp để mở nhật ký đã lọc.",
      "okTitle": "Tất cả đều ổn — nhấp để mở nhật ký tin nhắn của tích hợp này.",
      "receives": "Nhận"
    },
    "action": {
      "testConnection": "Kiểm tra kết nối",
      "restartTls": "Khởi động lại — áp dụng TLS vừa xoay vòng",
      "investigate": "Thông lượng, độ trễ và các lỗi gần đây",
      "edit": "Chỉnh sửa"
    },
    "auth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "mtls": "mTLS"
    },
    "fhirAuth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "oauth2": "OAuth2",
      "mtls": "mTLS"
    },
    "messages": {
      "recent50": "50 tin nhắn gần đây",
      "columns": {
        "time": "Thời gian",
        "id": "ID",
        "direction": "Hướng",
        "type": "Loại",
        "source": "Nguồn",
        "summary": "Tóm tắt",
        "status": "Trạng thái"
      },
      "dir": {
        "in": "VÀO",
        "out": "RA"
      }
    },
    "fhir": {
      "serverStatusHeader": "Trạng thái Máy chủ FHIR R4",
      "serverOnline": "Máy chủ Trực tuyến",
      "supportedResources": "Tài nguyên Được hỗ trợ",
      "version": "Phiên bản",
      "externalHeader": "Endpoint FHIR Bên ngoài",
      "registerEndpoint": "Đăng ký Endpoint",
      "columns": {
        "name": "Tên",
        "baseUrl": "URL Cơ sở",
        "auth": "Xác thực",
        "status": "Trạng thái",
        "lastChecked": "Kiểm tra Cuối",
        "actions": "Thao tác"
      },
      "emptyEndpoints": "Chưa có endpoint FHIR bên ngoài nào được đăng ký.",
      "revoked": "đã thu hồi",
      "statusOk": "OK",
      "statusError": "Lỗi",
      "testMetadata": "Kiểm tra /metadata",
      "edit": "Chỉnh sửa",
      "revoke": "Thu hồi"
    },
    "smart": {
      "header": "Ứng dụng SMART Đã đăng ký",
      "registerApp": "Đăng ký Ứng dụng",
      "columns": {
        "appName": "Tên Ứng dụng",
        "clientId": "Client ID",
        "scopes": "Phạm vi",
        "status": "Trạng thái",
        "lastModified": "Sửa đổi Cuối",
        "actions": "Thao tác"
      },
      "emptyApps": "Chưa có ứng dụng SMART nào được đăng ký.",
      "edit": "Chỉnh sửa",
      "rotateSecret": "Xoay vòng bí mật máy khách",
      "revoke": "Thu hồi"
    },
    "secretModal": {
      "title": "Hãy lưu client secret này ngay bây giờ",
      "body": "Secret này chỉ hiển thị một lần. Nếu bị mất, hãy xoay vòng secret để cấp lại secret mới.",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Sao chép Client ID",
      "copyClientSecret": "Sao chép Client Secret",
      "saved": "Tôi đã lưu lại"
    },
    "drawer": {
      "header": "Tích hợp #{{id}}",
      "refresh": "Làm mới",
      "close": "Đóng",
      "queueBlocked": "Hàng đợi bị chặn",
      "queueBlockedBody": "Một thông điệp lỗi đang khiến tích hợp này không gửi được. Các thông điệp phía sau sẽ chờ cho đến khi người vận hành xử lý.",
      "investigate": "Điều tra",
      "tiles": {
        "backlog": "Tồn đọng",
        "success24h": "Thành công 24h",
        "avgLatency24h": "Độ trễ trung bình 24h",
        "awaitingAck": "Chờ app-ACK"
      },
      "charts": {
        "throughput": "Thông lượng (24h)",
        "throughputSub": "Nhóm theo giờ. Xếp chồng: gửi đi hoàn tất + thất bại; nhận vào trên trục phụ.",
        "successRate": "Tỷ lệ thành công (24h)",
        "successRateSub": "Mỗi nhóm: hoàn tất / (hoàn tất + thất bại). Khoảng trống là nhóm rảnh.",
        "ackLatency": "Độ trễ ACK (24h)",
        "ackLatencySub": "Thời gian giữa lúc gửi và nhận ACK. avg là nét liền, p95 là nét đứt."
      },
      "series": {
        "outCompleted": "Gửi đi · hoàn tất",
        "outFailed": "Gửi đi · thất bại",
        "inReceived": "Nhận vào · đã nhận",
        "successPct": "Thành công %",
        "avg": "avg",
        "p95": "p95"
      },
      "recentFailures": "Lỗi gần đây",
      "viewAll": "Xem tất cả →",
      "noFailures": "Không có thông điệp lỗi trong cửa sổ gần đây. 🎉"
    }
  },
  "integrationStatus": {
    "connected": "Đã kết nối",
    "disconnected": "Đã ngắt kết nối",
    "error": "Lỗi"
  },
  "integrationDirection": {
    "server": "Máy chủ",
    "client": "Máy khách"
  },
  "messageStatus": {
    "sent": "Đã gửi",
    "received": "Đã nhận",
    "error": "Lỗi",
    "acknowledged": "Đã xác nhận"
  },
  "smartAppStatus": {
    "active": "Hoạt động",
    "revoked": "Đã thu hồi"
  },
  "interfaceMessageStatus": {
    "pending": "Đang chờ",
    "processing": "Đang xử lý",
    "completed": "Hoàn tất",
    "received": "Đã nhận",
    "processed": "Đã xử lý",
    "failed": "Thất bại",
    "error": "Lỗi",
    "rejected": "Bị từ chối",
    "deadLetter": "Thư chết",
    "skipped": "Đã bỏ qua",
    "awaitingAppAck": "Đang chờ ACK ứng dụng"
  },
  "interfaceDirection": {
    "in": "Đến",
    "out": "Đi"
  },
  "attemptOutcome": {
    "sent": "Đã gửi",
    "appNak": "App NAK",
    "timeout": "Hết thời gian",
    "networkError": "Lỗi mạng"
  },
  "fhirEndpoint": {
    "titleEdit": "Sửa Endpoint FHIR",
    "titleRegister": "Đăng ký Endpoint FHIR",
    "subtitle": "Các đối tác FHIR R4 bên ngoài mà gateway giao tiếp theo hướng outbound. Nút Test Connection trên danh sách tích hợp dò <code>/metadata</code> với auth + TLS đã cấu hình.",
    "back": "Quay lại",
    "cancel": "Hủy",
    "storedBlank": "Đã lưu — để trống để giữ nguyên",
    "save": {
      "changes": "Lưu Thay Đổi",
      "register": "Đăng ký Endpoint"
    },
    "section": {
      "basics": "Cơ bản",
      "auth": "Xác thực",
      "tls": "TLS"
    },
    "fields": {
      "name": "Tên",
      "baseUrl": "Base URL",
      "description": "Mô tả",
      "active": "Hoạt động — bỏ chọn để soft-revoke.",
      "method": "Phương thức",
      "username": "Tên người dùng",
      "password": "Mật khẩu",
      "bearerToken": "Bearer token",
      "tokenUrl": "Token URL",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "scope": "Scope"
    },
    "placeholder": {
      "name": "Partner Hospital FHIR",
      "baseUrl": "https://partner.example.com/fhir/R4",
      "tokenUrl": "https://partner.example.com/oauth/token",
      "scope": "system/*.read"
    },
    "helper": {
      "baseUrl": "Yêu cầu https:// (chấp nhận http://localhost cho phát triển). /metadata ở cuối được tự động thêm trong khi Test.",
      "oauth2": "Việc lấy token OAuth2 đã được nối ở phía quản trị; bộ lấy runtime sẽ có ở bản tiếp theo. Hiện tại, hãy điền giá trị và chạy Test để xác minh phần cấu hình còn lại.",
      "tls": "Dán root CA để ghim chứng chỉ máy chủ của đối tác, hoặc dán client cert + key cho mTLS. Chỉ riêng CA hoạt động với kho gốc hệ thống cho các CA nổi tiếng."
    },
    "option": {
      "method": {
        "none": "Không có",
        "basic": "HTTP Basic",
        "bearer": "Bearer token",
        "oauth2": "OAuth2 client_credentials",
        "clientCert": "Client certificate (mTLS)"
      }
    },
    "tlsLabel": {
      "ca": "Server CA (PEM) — tùy chọn với hầu hết đối tác",
      "clientCertRequired": "Client certificate (PEM) — bắt buộc",
      "clientCertMtls": "Client certificate (PEM) — cho mTLS",
      "clientKeyRequired": "Client private key (PEM) — bắt buộc",
      "clientKeyOptional": "Client private key (PEM)"
    },
    "validation": {
      "nameRequired": "Tên là bắt buộc",
      "baseUrlRequired": "Base URL là bắt buộc",
      "baseUrlInvalid": "URL cơ sở phải là URL http(s) hợp lệ",
      "basicUsername": "Basic auth yêu cầu tên người dùng",
      "basicPassword": "Basic auth yêu cầu mật khẩu",
      "bearerToken": "Bearer auth yêu cầu token",
      "clientCertKey": "Xác thực Client-certificate yêu cầu cert + key"
    }
  },
  "smartApp": {
    "titleEdit": "Chỉnh sửa ứng dụng SMART",
    "titleRegister": "Đăng ký ứng dụng SMART",
    "subtitle": "Đăng ký client SMART on FHIR. Client ID được tạo tự động cho bạn; client secret chỉ hiển thị đúng một lần sau khi tạo hoặc xoay vòng.",
    "back": "Quay lại",
    "cancel": "Hủy",
    "save": "Lưu thay đổi",
    "register": "Đăng ký",
    "fields": {
      "appName": "Tên ứng dụng",
      "redirectUris": "URI chuyển hướng",
      "scopes": "Phạm vi (scope)",
      "launchUrl": "URL khởi chạy",
      "logoUrl": "URL logo",
      "active": "Hoạt động — bỏ chọn để thu hồi mềm ứng dụng này."
    },
    "placeholder": {
      "appName": "Trình khởi chạy EHR của tôi"
    },
    "helper": {
      "redirectUris": "Mỗi dòng một URI. Bắt buộc dùng https:// (http://localhost cũng được chấp nhận khi phát triển)."
    },
    "secretModal": {
      "title": "Hãy lưu client secret này ngay bây giờ",
      "body": "Secret này chỉ hiển thị một lần. Nếu bị mất, hãy xoay vòng secret để cấp lại secret mới.",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Sao chép Client ID",
      "copyClientSecret": "Sao chép Client Secret",
      "saved": "Tôi đã lưu lại"
    },
    "validation": {
      "nameRequired": "Tên là bắt buộc",
      "redirectUriRequired": "Cần ít nhất một URI chuyển hướng",
      "scopeRequired": "Cần ít nhất một phạm vi (scope)"
    }
  },
  "interfaceLog": {
    "list": {
      "title": "Nhật ký Tin nhắn Giao tiếp",
      "subtitle": "Tin nhắn HL7 đến + đi trên mọi tích hợp đang hoạt động.",
      "refresh": "Làm mới",
      "loading": "Đang tải tin nhắn…",
      "empty": "Không có tin nhắn nào khớp với bộ lọc hiện tại.",
      "pagination": "{{total}} tin nhắn • trang {{page}} trên {{pages}}",
      "prev": "Trước",
      "next": "Sau",
      "archived": "(lưu trữ)"
    },
    "relative": {
      "secondsAgo": "{{n}}s trước",
      "minutesAgo": "{{n}}p trước",
      "hoursAgo": "{{n}}g trước"
    },
    "filter": {
      "header": "Bộ lọc",
      "direction": "Hướng",
      "status": "Trạng thái",
      "messageType": "Loại tin nhắn",
      "msh10": "MSH-10 chứa",
      "integrationId": "ID tích hợp",
      "includeArchive": "Bao gồm lưu trữ",
      "clear": "Xóa bộ lọc",
      "any": "Bất kỳ",
      "messageTypePlaceholder": "vd. ADT^A01",
      "controlIdPlaceholder": "id điều khiển"
    },
    "columns": {
      "id": "ID",
      "dir": "Hướng",
      "integ": "Tích hợp",
      "type": "Loại",
      "msh10": "MSH-10",
      "status": "Trạng thái",
      "ack": "ACK",
      "attempts": "Số lần thử",
      "when": "Khi nào"
    },
    "detail": {
      "eyebrow": "Tin nhắn {{direction}}",
      "close": "Đóng",
      "loading": "Đang tải…",
      "tabs": {
        "overview": "Tổng quan",
        "rawHl7": "HL7 thô",
        "attempts": "Lần thử"
      },
      "operatorActions": "Thao tác của người vận hành",
      "retry": "Thử lại",
      "skip": "Bỏ qua",
      "abandon": "Hủy bỏ",
      "resendAsNew": "Gửi lại như mới",
      "skipReason": "Lý do bỏ qua",
      "abandonReason": "Lý do hủy bỏ",
      "actionsHelper": "Các thao tác được kiểm toán cùng ID người dùng + lý do. Bỏ qua + Hủy bỏ yêu cầu lý do.",
      "overview": {
        "direction": "Hướng",
        "integration": "Tích hợp",
        "type": "Loại",
        "msh10": "MSH-10",
        "status": "Trạng thái",
        "ackCode": "Mã ACK",
        "attempts": "Lần thử",
        "created": "Đã tạo",
        "ackReceived": "Đã nhận ACK",
        "nextRetry": "Lần thử tiếp theo",
        "ackText": "Văn bản ACK",
        "lastError": "Lỗi cuối",
        "sourceEventId": "ID sự kiện nguồn"
      },
      "rawViewer": {
        "permissionDenied": "HL7 thô đã giải mã yêu cầu quyền <code>INTERFACE_OPERATE</code>.",
        "notAvailable": "Không có payload thô cho tin nhắn này.",
        "bytes": "{{bytes}} byte",
        "copy": "Sao chép"
      },
      "attempts": {
        "inboundInfo": "Lịch sử lần thử chỉ được theo dõi cho tin nhắn gửi đi. Tin nhắn đến được xử lý một lần mỗi MSH-10; việc truyền lại trả về ACK đã lưu trong bộ nhớ đệm mà không có lần thử mới.",
        "totalAttempts": "Tổng số lần thử",
        "nextAt": " (lần tiếp theo lúc {{time}})",
        "refresh": "Làm mới",
        "loading": "Đang tải lần thử…",
        "error": "Không thể tải lần thử.",
        "empty": "Chưa ghi nhận lần thử nào. Worker ghi một dòng mỗi lần gửi; danh sách này sẽ điền sau lần nhận đầu tiên.",
        "columns": {
          "when": "Khi nào",
          "outcome": "Kết quả",
          "ack": "ACK",
          "duration": "Thời lượng",
          "detail": "Chi tiết"
        }
      }
    }
  },
  "thirdPartyApp": {
    "list": {
      "title": "Ứng dụng Bên thứ ba",
      "subtitle": "Cấu hình các ứng dụng bên ngoài có thể được khởi chạy từ VynaEMR với ngữ cảnh bệnh nhân",
      "addApp": "Thêm Ứng dụng",
      "searchPlaceholder": "Tìm ứng dụng theo tên, mã hoặc danh mục...",
      "emptyTitle": "Chưa cấu hình ứng dụng nào",
      "emptyBody": "Thêm các ứng dụng bên ngoài như trình xem PACS, cổng xét nghiệm hoặc hệ thống dược.",
      "columns": {
        "application": "Ứng dụng",
        "category": "Danh mục",
        "url": "URL",
        "security": "Bảo mật",
        "display": "Hiển thị",
        "status": "Trạng thái",
        "actions": "Thao tác"
      }
    },
    "badge": {
      "jwt": "JWT",
      "jwtSigned": "Đã ký JWT",
      "hmac": "HMAC",
      "hmacSigned": "Đã ký HMAC",
      "none": "Không có",
      "chart": "Biểu đồ",
      "sidebar": "Thanh bên",
      "active": "Hoạt động",
      "inactive": "Không hoạt động"
    },
    "action": {
      "testLaunch": "Chạy thử",
      "edit": "Chỉnh sửa",
      "deactivate": "Vô hiệu hóa"
    },
    "form": {
      "titleEdit": "Chỉnh sửa Ứng dụng",
      "titleNew": "Ứng dụng Mới",
      "fields": {
        "appCode": "Mã Ứng dụng",
        "appName": "Tên Ứng dụng",
        "category": "Danh mục",
        "baseUrl": "URL Cơ sở",
        "launchMethod": "Phương thức Khởi chạy",
        "paramMappings": "Ánh xạ Tham số",
        "enableJwt": "Bật Ký Token JWT",
        "sharedSecret": "Bí mật Chia sẻ (khóa ký JWT)",
        "enableHmac": "Bật Chữ ký URL (HMAC)",
        "hmacKey": "Khóa HMAC",
        "requiredPermission": "Quyền Bắt buộc",
        "displayOrder": "Thứ tự Hiển thị",
        "showInChart": "Hiển thị trong Biểu đồ",
        "showInSidebar": "Hiển thị trong Thanh bên"
      },
      "placeholder": {
        "appCode": "vd. pacs_viewer",
        "appName": "vd. PACS Viewer",
        "baseUrl": "https://pacs.hospital.com/viewer",
        "paramName": "Tên tham số URL",
        "unchanged": "(không đổi)",
        "sharedSecret": "Nhập bí mật chia sẻ",
        "hmacKey": "Nhập khóa HMAC",
        "requiredPermission": "vd. RESULT_VIEW (để trống = mọi người dùng)"
      },
      "addParameter": "Thêm Tham số",
      "cancel": "Hủy",
      "submitUpdate": "Cập nhật Ứng dụng",
      "submitCreate": "Tạo Ứng dụng"
    },
    "paramSource": {
      "patientMrn": "MRN Bệnh nhân",
      "patientName": "Tên Bệnh nhân",
      "patientDob": "DOB Bệnh nhân",
      "encounterId": "ID Lần khám",
      "encounterNumber": "Số Lần khám",
      "orderNumber": "Số Y lệnh",
      "userName": "Tên Người dùng Hiện tại",
      "userId": "ID Người dùng Hiện tại",
      "timestamp": "Dấu thời gian Hiện tại"
    },
    "launch": "Khởi chạy {{name}}"
  },
  "integrationForm": {
    "titleEdit": "Chỉnh sửa tích hợp",
    "titleAdd": "Thêm tích hợp",
    "subtitle": "Các giao diện MLLP và HL7-over-HTTP dựa trên VynaHL7. Tài liệu chứng chỉ được lưu trên bản ghi tích hợp; việc xoay vòng có hiệu lực vào lần khởi động lại máy chủ hoặc máy khách kế tiếp.",
    "back": "Quay lại",
    "cancel": "Hủy",
    "saveChanges": "Lưu thay đổi",
    "addIntegration": "Thêm tích hợp",
    "storedBlank": "Đã lưu — để trống để giữ nguyên",
    "selectSibling": "— chọn một tích hợp cùng cấp —",
    "section": {
      "basics": "Thông tin cơ bản",
      "connection": "Kết nối",
      "tls": "TLS / mTLS",
      "auth": "Xác thực",
      "ackDelivery": "Xác nhận & Gửi",
      "outboundRouting": "Định tuyến gửi đi",
      "inboundTrust": "Mức tin cậy đầu vào"
    },
    "fields": {
      "name": "Tên",
      "type": "Loại",
      "direction": "Hướng",
      "description": "Mô tả",
      "active": "Hoạt động — bỏ chọn để vô hiệu hóa mềm giao diện này.",
      "host": "Máy chủ",
      "port": "Cổng",
      "enableTls": "Bật TLS — sử dụng",
      "serverCert": "Chứng chỉ máy chủ (PEM)",
      "clientCert": "Chứng chỉ máy khách (PEM) — tùy chọn cho mTLS",
      "serverKey": "Khóa riêng máy chủ (PEM)",
      "clientKey": "Khóa riêng máy khách (PEM)",
      "serverCa": "Kho tin cậy CA máy khách (PEM) — cho mTLS",
      "clientCa": "Kho tin cậy CA máy chủ (PEM) — tùy chọn, dự phòng về gốc hệ thống",
      "method": "Phương thức",
      "username": "Tên người dùng",
      "password": "Mật khẩu",
      "bearerToken": "Mã thông báo Bearer",
      "inboundAck": "Chính sách ACK đến",
      "outboundAck": "Chính sách ACK đi",
      "processingTimeout": "Hết thời gian xử lý (ms)",
      "pendingAckTtl": "TTL ACK đang chờ (giây)",
      "networkRetry": "Số lần thử lại mạng tối đa",
      "appNakRetry": "Số lần thử lại NAK ứng dụng tối đa",
      "reverseIntegration": "Tích hợp kênh ngược",
      "outboundTypes": "Loại thông điệp nhận",
      "outboundEvents": "Đăng ký theo sự kiện",
      "receivingApplication": "Ứng dụng nhận (MSH-5)",
      "receivingFacility": "Cơ sở nhận (MSH-6)",
      "inboundTrustProfile": "Đối tác này được phép"
    },
    "placeholder": {
      "name": "Hospital LIS ADT",
      "description": "Ghi chú ngắn về giao diện này — người sở hữu, mục đích, loại thông điệp, v.v.",
      "hostServer": "0.0.0.0",
      "hostClient": "lis.hospital.local",
      "portMllp": "2575",
      "portOther": "443",
      "username": "svc-vynaemr",
      "outboundEvents": "ADT^A01, SIU^S12",
      "receivingApplication": "LAB_A",
      "receivingFacility": "CENTRAL_LAB"
    },
    "helper": {
      "hostServer": "Địa chỉ liên kết. Dùng 0.0.0.0 để lắng nghe trên mọi giao diện.",
      "hostClient": "Máy chủ từ xa mà máy khách này nên kết nối tới.",
      "tlsHandshake": "cho quá trình bắt tay.",
      "authClientCert": "Chứng chỉ/khóa máy khách lấy từ phần TLS ở trên.",
      "authNone": "Không gắn tiêu đề xác thực HTTP.",
      "authRs7": "{{call}} kết nối điều này vào mọi yêu cầu đi.",
      "ackDefaults": "Kiểm soát cách cổng ACK các thông điệp HL7 đến và cách diễn giải ACK phản hồi khi gửi đi. Giá trị mặc định",
      "ackDefaultsTail": "khớp với hành vi trước 0.19.0 — thay đổi theo từng đối tác khi cần.",
      "processingTimeout": "Giới hạn cho xử lý nội tuyến ACK ứng dụng đồng bộ. Hết thời gian → AE + thử lại hàng đợi nền.",
      "pendingAckTtl": "Thời gian chờ ACK ứng dụng ở chế độ nâng cao trước khi bộ quét hết thời gian.",
      "networkRetry": "Số lần thử lại cho lỗi truyền tải trước khi hàng đợi bị chặn.",
      "appNakRetry": "Số lần thử lại cho AE/AR/CE/CR — thường 2–3 vì cùng một tải hiếm khi thành công khi thử lại.",
      "reverse": "Chế độ nâng cao gửi ACK ứng dụng thực qua một tích hợp cùng cấp trỏ tới điểm cuối ngược của đối tác. Hãy tạo tích hợp cùng cấp như một bản ghi riêng trước, rồi liên kết tại đây.",
      "outboundRouting": "Những gì đối tác này nhận. Không chọn gì nghĩa là tích hợp này không phải đích gửi đi và sẽ không có thông điệp nào được gửi tới.",
      "outboundEvents": "Tùy chọn, phân tách bằng dấu phẩy. Hẹp hơn cả một loại — dành cho đối tác chỉ muốn một số sự kiện.",
      "receivingDefaults": "MSH-5 và MSH-6 nêu tên bên nhận trên mọi thông điệp gửi tới đây. Để trống để dùng tên giao diện.",
      "inboundTrust": "Đối tác này được phép khẳng định điều gì về danh tính bệnh nhân. Xác thực cho biết ai đang kết nối; thiết lập này cho biết họ được phép nói gì với chúng ta. Hãy giữ mặc định triển khai trừ khi đầu mối này thực sự là hệ thống chủ đăng ký."
    },
    "option": {
      "type": {
        "mllp": "MLLP (HL7 v2 trên TCP)",
        "hoh": "HoH (HL7 trên HTTPS)",
        "fhir": "FHIR R4"
      },
      "direction": {
        "client": "Máy khách (đi)",
        "server": "Máy chủ (đến)"
      },
      "method": {
        "none": "Không",
        "basic": "HTTP Basic",
        "bearer": "Mã thông báo Bearer",
        "clientCert": "Chứng chỉ máy khách (mTLS)"
      }
    },
    "ack": {
      "inbound": {
        "acceptOnly": "AA ngay lập tức (mặc định hiện tại)",
        "honorMsh16": "đọc MSH-15/16 theo từng thông điệp",
        "forceSync": "xử lý nội tuyến, AA/AE/AR theo kết quả",
        "forceEnhanced": "CA ngay + ACK ứng dụng qua kênh ngược"
      },
      "outbound": {
        "fireAndForget": "gửi rồi bỏ qua (mặc định hiện tại)",
        "expectSync": "đặt MSH-16=AL, thử lại khi AE/AR",
        "expectEnhanced": "chờ CA + ACK ứng dụng tiếp theo"
      }
    },
    "validation": {
      "nameRequired": "Tên là bắt buộc",
      "hostRequired": "Máy chủ là bắt buộc",
      "mllpPort": "Tích hợp MLLP cần một cổng",
      "portNumber": "Cổng phải là một số",
      "tlsServerCertKey": "Máy chủ TLS cần cả chứng chỉ và khóa",
      "basicUsername": "Xác thực Basic cần tên người dùng",
      "basicPassword": "Xác thực Basic cần mật khẩu",
      "bearerToken": "Xác thực Bearer cần mã thông báo",
      "enhancedReverse": "Chế độ ACK nâng cao cần một tích hợp ngược — hãy chọn một mục bên dưới.",
      "outboundEvent": "\"{{value}}\" không phải thông điệp hệ thống này gửi — hãy dùng loại như ADT, hoặc sự kiện như ADT^A01."
    },
    "trust": {
      "useDeploymentDefault": "Dùng mặc định triển khai",
      "observer": "Quan sát — không bao giờ tạo hoặc thay đổi bệnh nhân",
      "demographics": "Nhân khẩu học — có thể sửa bệnh nhân đã có, kể cả thông báo tử vong; không tạo mới",
      "registration": "Đăng ký — còn có thể tạo bệnh nhân và hợp nhất hồ sơ"
    },
    "__review_inboundTrust": "Machine-authored — needs native review"
  },
  "thirdPartyAppCategory": {
    "imaging": "Chẩn đoán hình ảnh",
    "laboratory": "Xét nghiệm",
    "pharmacy": "Dược",
    "specialty": "Chuyên khoa",
    "portal": "Cổng thông tin",
    "billing": "Lập hóa đơn",
    "other": "Khác"
  },
  "thirdPartyLaunchMethod": {
    "redirect": "Chuyển hướng",
    "popup": "Cửa sổ Popup",
    "iframe": "iframe",
    "newTab": "Tab Mới"
  },
  "cdsRule": {
    "form": {
      "titleEdit": "Chỉnh sửa quy tắc CDS",
      "titleCreate": "Tạo quy tắc CDS",
      "ruleName": "Tên quy tắc",
      "ruleType": "Loại quy tắc",
      "selectPlaceholder": "Chọn…",
      "severity": "Mức độ nghiêm trọng",
      "triggerEvent": "Sự kiện kích hoạt",
      "actionType": "Loại hành động",
      "description": "Mô tả",
      "active": "Đang hoạt động",
      "cancel": "Hủy",
      "submitUpdate": "Cập nhật quy tắc",
      "submitCreate": "Tạo quy tắc",
      "createdOk": "Tạo quy tắc thành công",
      "createFailed": "Không thể tạo quy tắc",
      "updatedOk": "Cập nhật quy tắc thành công",
      "updateFailed": "Không thể cập nhật quy tắc",
      "validation": {
        "nameRequired": "Tên quy tắc là bắt buộc",
        "typeRequired": "Loại quy tắc là bắt buộc",
        "descriptionRequired": "Mô tả là bắt buộc",
        "triggerRequired": "Sự kiện kích hoạt là bắt buộc",
        "actionRequired": "Loại hành động là bắt buộc"
      }
    },
    "list": {
      "title": "Quy tắc CDS",
      "subtitle": "Quản lý quy tắc hỗ trợ quyết định lâm sàng",
      "addRule": "Thêm quy tắc",
      "loading": "Đang tải quy tắc CDS…",
      "loadError": "Không tải được quy tắc CDS.",
      "empty": "Chưa cấu hình quy tắc CDS nào.",
      "columns": {
        "ruleName": "Tên quy tắc",
        "type": "Loại",
        "severity": "Mức độ nghiêm trọng",
        "description": "Mô tả",
        "status": "Trạng thái",
        "actions": "Thao tác"
      },
      "toggleActive": "Nhấp để vô hiệu hóa",
      "toggleInactive": "Nhấp để kích hoạt",
      "active": "Đang hoạt động",
      "inactive": "Không hoạt động",
      "editRule": "Chỉnh sửa quy tắc",
      "statusUpdated": "Đã cập nhật trạng thái quy tắc",
      "statusUpdateFailed": "Cập nhật trạng thái quy tắc không thành công"
    }
  },
  "cdsSeverity": {
    "info": "Thông tin",
    "warning": "Cảnh báo",
    "critical": "Nghiêm trọng"
  },
  "cdsTriggerEvent": {
    "orderSign": "Ký y lệnh",
    "orderSelect": "Chọn y lệnh",
    "patientView": "Xem bệnh nhân",
    "medicationPrescribe": "Kê đơn thuốc",
    "resultReceived": "Nhận kết quả",
    "patientAdmit": "Tiếp nhận bệnh nhân"
  },
  "cdsActionType": {
    "alert": "Báo động",
    "warning": "Cảnh báo",
    "hardStop": "Dừng bắt buộc",
    "suggestion": "Gợi ý",
    "notification": "Thông báo"
  },
  "cdsRuleType": {
    "drugInteraction": "Tương tác thuốc",
    "drugAllergy": "Dị ứng thuốc",
    "duplicateOrder": "Y lệnh trùng lặp",
    "custom": "Tùy chỉnh",
    "clinicalAlert": "Cảnh báo lâm sàng",
    "sepsisScreen": "Sàng lọc nhiễm khuẩn huyết"
  },
  "system": {
    "title": "Cấu hình hệ thống",
    "subtitle": "Cài đặt ứng dụng, bảo mật và tình trạng hệ thống",
    "restartServices": "Khởi động lại dịch vụ",
    "restartToast": "Khởi động lại dịch vụ (chỗ giữ chỗ - cần xác nhận)",
    "loadError": "Tải Cấu hình hệ thống thất bại",
    "section": {
      "systemInfo": "Thông tin hệ thống",
      "systemInfoDesc": "Phiên bản, thời gian hoạt động và tình trạng dịch vụ",
      "general": "Cài đặt chung",
      "generalDesc": "Tên ứng dụng, múi giờ và thương hiệu",
      "security": "Cài đặt bảo mật",
      "securityDesc": "Chính sách mật khẩu, MFA và quản lý phiên",
      "notifications": "Cài đặt thông báo",
      "notificationsDesc": "Cấu hình cổng email và SMS",
      "integration": "Mặc định tích hợp",
      "integrationDesc": "Cấu hình mặc định MLLP, FHIR và HL7",
      "featureFlags": "Cờ tính năng",
      "featureFlagsDesc": "Bật hoặc tắt các tính năng hệ thống",
      "patientAccess": "Patient Access",
      "patientAccessDesc": "Default patient visibility scope"
    },
    "info": {
      "version": "Phiên bản",
      "uptime": "Thời gian hoạt động",
      "database": "Cơ sở dữ liệu",
      "redis": "Redis",
      "microservices": "Vi dịch vụ",
      "conn": "kết nối"
    },
    "uptime": {
      "running": "Đang chạy",
      "unknown": "Không xác định",
      "up": "Đang hoạt động"
    },
    "subsection": {
      "passwordPolicy": "Chính sách mật khẩu",
      "mfa": "Xác thực đa yếu tố",
      "sessionLockout": "Phiên và khóa",
      "emailConfig": "Cấu hình email",
      "smsGateway": "Cổng SMS",
      "mllpDefaults": "Mặc định MLLP",
      "fhirConfig": "Cấu hình FHIR",
      "hl7Encoding": "Mã hóa HL7 v2"
    },
    "fields": {
      "appName": "Tên ứng dụng",
      "timezone": "Múi giờ",
      "dateFormat": "Định dạng ngày",
      "supportEmail": "Email hỗ trợ",
      "logoUrl": "URL logo",
      "maintenanceMode": "Chế độ bảo trì (vô hiệu hóa truy cập người dùng)",
      "upload": "Tải lên",
      "minPasswordLength": "Độ dài mật khẩu tối thiểu",
      "passwordExpiry": "Mật khẩu hết hạn (ngày)",
      "requireUppercase": "Yêu cầu chữ hoa",
      "requireNumbers": "Yêu cầu chữ số",
      "requireSpecialChars": "Yêu cầu ký tự đặc biệt",
      "enableMfa": "Bật MFA",
      "mfaMethod": "Phương thức MFA",
      "sessionTimeout": "Hết thời gian phiên (phút)",
      "maxLoginAttempts": "Số lần đăng nhập tối đa",
      "lockoutDuration": "Thời gian khóa (phút)",
      "smtpHost": "Máy chủ SMTP",
      "smtpPort": "Cổng SMTP",
      "smtpUser": "Người dùng SMTP",
      "fromEmail": "Email người gửi",
      "useTls": "Sử dụng TLS",
      "enabled": "Đã bật",
      "provider": "Nhà cung cấp",
      "fromNumber": "Số người gửi",
      "defaultPort": "Cổng mặc định",
      "timeoutSeconds": "Hết thời gian (giây)",
      "retryCount": "Số lần thử lại",
      "fhirBaseUrl": "FHIR Base URL",
      "authMethod": "Phương thức xác thực",
      "fieldSeparator": "Dấu phân tách trường",
      "encodingChars": "Ký tự mã hóa",
      "visibilityScope": "Visibility scope",
      "visibilityScopeDesc": "Who can see a patient by default. Facilities may override this; the stricter side always wins. Takes effect immediately."
    },
    "option": {
      "tz": {
        "singapore": "Châu Á/Singapore (UTC+8)",
        "hongKong": "Châu Á/Hồng Kông (UTC+8)",
        "kualaLumpur": "Châu Á/Kuala Lumpur (UTC+8)",
        "bangkok": "Châu Á/Bangkok (UTC+7)",
        "tokyo": "Châu Á/Tokyo (UTC+9)",
        "kolkata": "Châu Á/Kolkata (UTC+5:30)",
        "sydney": "Úc/Sydney (UTC+11)"
      },
      "mfa": {
        "totp": "TOTP (Ứng dụng xác thực)",
        "sms": "SMS",
        "email": "Email"
      },
      "fhirAuth": {
        "none": "Không có",
        "oauth2": "OAuth 2.0",
        "basic": "Basic Auth"
      },
      "visibility": {
        "organization": "Organization - shared health system",
        "facility": "Facility - shared facility (default)",
        "department": "Department - shared encounter department"
      }
    },
    "save": {
      "general": "Lưu cài đặt chung",
      "security": "Lưu cài đặt bảo mật",
      "notifications": "Lưu cài đặt thông báo",
      "integration": "Lưu cấu hình tích hợp",
      "features": "Lưu cờ tính năng",
      "patientaccess": "Save Patient Access"
    },
    "sectionName": {
      "general": "chung",
      "security": "bảo mật",
      "notifications": "thông báo",
      "integration": "tích hợp",
      "features": "cờ tính năng",
      "patientaccess": "Patient Access"
    },
    "toast": {
      "uploadPlaceholder": "Tải lên logo (chỗ giữ chỗ)",
      "saved": "Đã lưu cài đặt {{section}} thành công",
      "saveFailed": "Lưu cài đặt thất bại"
    },
    "featureFlag": {
      "patientMerge": {
        "label": "Hợp nhất bệnh nhân",
        "description": "Bật chức năng hợp nhất/tách bệnh nhân"
      },
      "breakGlass": {
        "label": "Truy cập khẩn cấp",
        "description": "Cho phép ghi đè khẩn cấp đối với hồ sơ hạn chế"
      },
      "fhirApi": {
        "label": "FHIR R4 API",
        "description": "Cung cấp các endpoint FHIR R4 cho hệ thống bên ngoài"
      },
      "smartApps": {
        "label": "Ứng dụng SMART on FHIR",
        "description": "Cho phép ứng dụng SMART của bên thứ ba kết nối"
      },
      "clinicalDecisionSupport": {
        "label": "Hỗ trợ quyết định lâm sàng",
        "description": "Bật CDS hooks cho nhập y lệnh"
      },
      "telemedicine": {
        "label": "Mô-đun khám bệnh từ xa",
        "description": "Tư vấn video và theo dõi từ xa"
      },
      "patientPortal": {
        "label": "Cổng bệnh nhân",
        "description": "Cổng dành cho bệnh nhân xem hồ sơ và cuộc hẹn"
      },
      "analyticsDashboard": {
        "label": "Bảng điều khiển phân tích",
        "description": "Bảng điều khiển phân tích và báo cáo nâng cao"
      },
      "medicationBarcode": {
        "label": "Quét mã vạch thuốc",
        "description": "Xác minh mã vạch cho việc cấp phát thuốc"
      },
      "autoCoding": {
        "label": "Tự động mã hóa (ICD/CPT)",
        "description": "Mã hóa chẩn đoán và thủ thuật hỗ trợ bởi AI"
      }
    }
  },
  "audit": {
    "title": "Nhật ký kiểm toán",
    "subtitle": "Nhật ký hoạt động hệ thống với theo dõi thay đổi chi tiết",
    "exportCsv": "Xuất CSV",
    "exportToast": "Đang xuất {{count}} mục kiểm toán dưới dạng CSV (chỗ giữ)",
    "searchPlaceholder": "Tìm theo người dùng…",
    "advanced": "Nâng cao",
    "breakGlassOnly": "Chỉ truy cập khẩn cấp",
    "fromTo": "Từ / Đến:",
    "fromDate": "Ngày bắt đầu",
    "toDate": "Ngày kết thúc",
    "clearFilters": "Xóa tất cả bộ lọc",
    "entriesFound": "Tìm thấy {{count}} mục",
    "noMatch": "Không có mục kiểm toán nào khớp với bộ lọc của bạn",
    "viewDetails": "Xem chi tiết",
    "detail": {
      "title": "Chi tiết mục kiểm toán",
      "timestamp": "Dấu thời gian",
      "user": "Người dùng",
      "action": "Hành động",
      "resource": "Tài nguyên",
      "ipAddress": "Địa chỉ IP",
      "breakGlass": "Truy cập khẩn cấp",
      "yes": "Có",
      "no": "Không",
      "details": "Chi tiết",
      "dataChanges": "Thay đổi dữ liệu",
      "before": "Trước",
      "after": "Sau",
      "result": "Kết quả"
    },
    "columns": {
      "timestamp": "Dấu thời gian",
      "user": "Người dùng",
      "action": "Hành động",
      "resource": "Tài nguyên",
      "resourceId": "ID tài nguyên",
      "ipAddress": "Địa chỉ IP",
      "details": "Chi tiết",
      "view": "Xem"
    },
    "filter": {
      "action": {
        "all": "Tất cả hành động",
        "create": "Tạo",
        "read": "Đọc",
        "update": "Cập nhật",
        "delete": "Xóa",
        "login": "Đăng nhập",
        "logout": "Đăng xuất",
        "export": "Xuất",
        "breakGlass": "Truy cập khẩn cấp"
      },
      "resource": {
        "all": "Tất cả tài nguyên",
        "patient": "Bệnh nhân",
        "encounter": "Lần khám",
        "order": "Y lệnh",
        "result": "Kết quả",
        "medication": "Thuốc",
        "user": "Người dùng",
        "system": "Hệ thống"
      }
    },
    "pagination": {
      "first": "Trang đầu",
      "last": "Trang cuối",
      "pageOf": "Trang {{page}} trên {{pages}}",
      "range": "{{from}}-{{to}} trên {{total}}"
    }
  },
  "taxonomy": {
    "title": "Phân loại Lâm sàng",
    "subtitle": "Tuyến dịch vụ nhóm các dịch vụ lâm sàng liên quan (Cardiovascular → Cardiology, EP Lab, Heart Failure Clinic). Cả hai đều cung cấp cho ma trận phân công dịch vụ ↔ địa điểm dùng cho lập lịch.",
    "addServiceLine": "Thêm Tuyến Dịch vụ",
    "addClinicalService": "Thêm Dịch vụ Lâm sàng",
    "tabs": {
      "serviceLines": "Tuyến Dịch vụ",
      "clinicalServices": "Dịch vụ Lâm sàng"
    },
    "searchLines": "Tìm tuyến dịch vụ...",
    "searchServices": "Tìm dịch vụ lâm sàng...",
    "empty": {
      "linesNone": "Chưa cấu hình tuyến dịch vụ nào.",
      "linesNoMatch": "Không có tuyến dịch vụ nào khớp.",
      "servicesNone": "Chưa cấu hình dịch vụ lâm sàng nào.",
      "servicesNoMatch": "Không có dịch vụ lâm sàng nào khớp."
    },
    "columns": {
      "name": "Tên",
      "code": "Mã",
      "description": "Mô tả",
      "services": "Dịch vụ",
      "status": "Trạng thái",
      "serviceLine": "Tuyến Dịch vụ",
      "specialty": "Chuyên khoa",
      "actions": "Thao tác"
    },
    "status": {
      "active": "Đang hoạt động",
      "inactive": "Ngừng hoạt động"
    },
    "editTitle": "Chỉnh sửa"
  },
  "systemStatus": {
    "connected": "Đã kết nối",
    "error": "Lỗi"
  },
  "escalation": {
    "title": "Escalation Rules",
    "subtitle": "Configure how an unacknowledged critical result is re-paged",
    "help": "An escalation rule is the re-paging ladder for a trigger event. A level fires when the ORIGINAL page is older than its delay (in minutes) and the result is still unacknowledged; every user holding the listed roles at the encounter's facility is then paged. Only the critical_result trigger is wired to a consumer today, so rules can be edited but not created.",
    "loadError": "Failed to load escalation rules.",
    "empty": "No escalation rules configured.",
    "active": "Active",
    "inactive": "Inactive",
    "selectPrompt": "Select a rule to edit its ladder.",
    "list": {
      "header": "Rules",
      "levelCount": "{{n}} levels"
    },
    "editor": {
      "ruleName": "Rule Name",
      "triggerEvent": "Trigger Event",
      "initialRecipient": "Initial page goes to: {{role}}",
      "active": "Active",
      "ladder": "Escalation Ladder",
      "level": "Level",
      "delayMinutes": "Delay (minutes)",
      "roles": "Roles Paged",
      "addRole": "Add a role...",
      "noRoles": "No roles selected — this level will be rejected.",
      "noLevels": "This rule has no levels. Add at least one.",
      "addLevel": "Add Level",
      "removeLevel": "Remove level {{level}}",
      "removeRole": "Remove role {{role}}",
      "reset": "Reset",
      "save": "Save Rule",
      "holderCount": "{{count}} người đảm nhiệm",
      "unstaffedBadge": "chưa có người",
      "unstaffedWarning": "Các vai trò sau không có người đảm nhiệm nên những cấp đó sẽ không gọi được ai: {{roles}}. Hãy gán vai trò cho nhân viên tại Quản trị → Người dùng."
    },
    "validation": {
      "nameRequired": "Rule name is required.",
      "ladderRequired": "The ladder must have at least one level.",
      "levelInvalid": "Every level number must be 1 or greater.",
      "levelDuplicate": "Level numbers must be unique.",
      "delayInvalid": "Level {{level}}: the delay must be a whole number of minutes, 0 or greater.",
      "rolesRequired": "Level {{level}}: select at least one role.",
      "unknownRole": "Unknown role: {{role}}."
    },
    "toast": {
      "saved": "Escalation rule saved",
      "saveFailed": "Failed to save escalation rule",
      "invalidLadder": "The escalation ladder was rejected: check the level numbers, delays and roles.",
      "notFound": "Escalation rule not found",
      "forbidden": "You do not have permission to edit escalation rules"
    }
  },
  "review": {
    "list": {
      "title": "Access Reviews",
      "empty": "No review campaigns yet. Open one to snapshot every live grant for certification.",
      "columns": {
        "name": "Campaign",
        "status": "Status",
        "dueDate": "Due",
        "progress": "Progress",
        "created": "Opened",
        "actions": "Actions"
      },
      "status": {
        "open": "Open",
        "closed": "Closed"
      },
      "progress": "{{pending}} of {{total}} pending",
      "create": {
        "namePlaceholder": "Campaign name (blank = dated default)",
        "dueLabel": "Due",
        "submit": "Open campaign"
      }
    },
    "detail": {
      "back": "All reviews",
      "columns": {
        "user": "User",
        "role": "Role",
        "facility": "Facility",
        "window": "Grant window",
        "grantedBy": "Granted by",
        "state": "Grant",
        "decision": "Decision",
        "decidedBy": "Decided by",
        "actions": "Actions"
      },
      "certify": "Certify",
      "revoke": "Revoke",
      "live": "live",
      "dead": "lapsed",
      "permanent": "permanent",
      "allFacilities": "All facilities",
      "close": "Close campaign",
      "delete": "Delete",
      "filter": {
        "label": "Show",
        "all": "All",
        "pending": "Pending",
        "decided": "Decided"
      },
      "decision": {
        "pending": "Pending",
        "certified": "Certified",
        "revoked": "Revoked"
      },
      "closeBlocked": "{{count}} item(s) still pending",
      "empty": "No grants were live when this campaign opened.",
      "confirmRevoke": {
        "title": "Revoke this grant?",
        "description": "The role grant is deleted for real — the user loses it immediately. This cannot be undone from the review.",
        "confirm": "Revoke grant"
      },
      "confirmClose": {
        "title": "Close this campaign?",
        "description": "Closed campaigns are the attestation record: items can no longer be decided and the campaign cannot be deleted.",
        "confirm": "Close campaign"
      },
      "confirmDelete": {
        "title": "Delete this campaign?",
        "description": "The open campaign and its undecided items are discarded. Only open campaigns can be deleted.",
        "confirm": "Delete campaign"
      }
    },
    "toast": {
      "created": "Review campaign opened",
      "createError": "Failed to open review campaign",
      "certified": "Grant certified",
      "revoked": "Grant revoked",
      "closed": "Review campaign closed",
      "deleted": "Review campaign deleted",
      "saveError": "Failed to save the decision"
    }
  },
  "sso": {
    "title": "Single sign-on",
    "subtitle": "Identity providers, email domains, and LDAP directories",
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "tabs": {
      "providers": "Providers",
      "directories": "Directories",
      "domains": "Domains",
      "scim": "SCIM provisioning"
    },
    "providers": {
      "new": "New provider",
      "edit": "Edit provider",
      "delete": "Delete provider",
      "empty": "No identity providers yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "kind": "Kind",
        "issuer": "Issuer",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Provider deleted. {{count}} logins kept.",
        "deleted": "Provider deleted.",
        "deleteFailed": "Could not delete the provider."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked. In-flight sign-in states and group mappings go with the provider.",
        "confirm": "Delete"
      }
    },
    "directories": {
      "new": "New directory",
      "edit": "Edit directory",
      "delete": "Delete directory",
      "empty": "No LDAP directories yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "host": "Host",
        "tls": "TLS",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Directory deleted. {{count}} logins kept.",
        "deleted": "Directory deleted.",
        "deleteFailed": "Could not delete the directory."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked, with their current roles. Directory-bound mappings go with the directory.",
        "confirm": "Delete"
      }
    },
    "domains": {
      "new": "Claim domain",
      "delete": "Release domain",
      "empty": "No email domains claimed yet.",
      "columns": {
        "domain": "Domain",
        "system": "Health system",
        "actions": "Actions"
      },
      "toast": {
        "created": "{{domain}} claimed.",
        "createFailed": "Could not claim the domain.",
        "deleted": "Domain released.",
        "deleteFailed": "Could not release the domain."
      },
      "deleteConfirm": {
        "title": "Release {{domain}}?",
        "description": "Staff with this email domain will no longer route to SSO.",
        "confirm": "Release"
      },
      "add": {
        "title": "Claim email domain",
        "description": "One domain routes to exactly one health system.",
        "confirm": "Claim",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "domain": "Domain"
      }
    },
    "scim": {
      "hint": "Point the identity provider's SCIM client at {{url}} \u2014 one bearer token per health system, pasted as the secret.",
      "copyUrl": "Copy URL",
      "urlCopied": "Tenant URL copied.",
      "new": "New token",
      "empty": "No SCIM tokens yet.",
      "columns": {
        "label": "Label",
        "system": "Health system",
        "prefix": "Prefix",
        "status": "Status",
        "actions": "Actions"
      },
      "revoke": "Revoke token",
      "toast": {
        "mintFailed": "Could not mint the token.",
        "revoked": "Token revoked.",
        "revokeFailed": "Could not revoke the token."
      },
      "revokeConfirm": {
        "title": "Revoke {{label}}?",
        "description": "The token stops authenticating immediately. In-flight sync cycles fail on their next call.",
        "confirm": "Revoke"
      },
      "mint": {
        "title": "Mint SCIM token",
        "description": "One token provisions exactly one health system. The secret renders once.",
        "confirm": "Mint",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "label": "Label"
      },
      "secret": {
        "title": "Token minted",
        "body": "Copy this secret into the identity provider now \u2014 it never renders again.",
        "secret": "Secret",
        "copy": "Copy secret",
        "copied": "Secret copied.",
        "dismiss": "Done"
      }
    },
    "providerForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit identity provider",
      "newTitle": "New identity provider",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "kind": "Protocol",
      "kindOidc": "OpenID Connect (OIDC)",
      "kindSaml": "SAML 2.0",
      "kindFlipHint": "Changing protocol clears the other protocol's settings on save.",
      "issuer": "Issuer URL",
      "issuerSamlHint": "The IdP entity ID — must exactly match the entity in the metadata below. URNs (e.g. ADFS) are fine.",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "secretKeep": "A secret is stored. Leave blank to keep it.",
      "secretUnset": "No secret stored (public client).",
      "secretNewHint": "Blank means no secret (public client).",
      "secretClear": "Clear the stored secret",
      "groupClaim": "Group claim",
      "metadata": "IdP metadata XML",
      "metadataHint": "Paste the IdP metadata XML. It must parse and name the entity ID above.",
      "save": "Save",
      "saving": "Saving…",
      "test": "Test connection",
      "testing": "Testing…",
      "toast": {
        "updated": "Provider updated.",
        "created": "Provider created.",
        "failed": "Could not save the provider.",
        "testFailed": "Could not test the provider."
      }
    },
    "maps": {
      "title": "Group mappings",
      "subtitle": "IdP groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this IdP group receive the role at sign-in.",
        "confirm": "Add",
        "group": "IdP group",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    },
    "directoryForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit LDAP directory",
      "newTitle": "New LDAP directory",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "host": "Host",
      "port": "Port",
      "portPlaceholder": "Default",
      "tlsMode": "TLS mode",
      "tlsVerify": "Verify TLS certificates",
      "caPem": "CA bundle (PEM)",
      "caSet": "A CA bundle is stored.",
      "caReplace": "Replace",
      "caEditHint": "Blank clears to system roots. Leave the toggle off to keep the stored bundle.",
      "caNewHint": "Blank means system roots. Paste the hospital root CA for private PKI.",
      "bindDn": "Bind DN",
      "bindPassword": "Bind password",
      "passwordKeep": "A password is stored. Leave blank to keep it.",
      "passwordUnset": "No password stored (anonymous search).",
      "passwordNewHint": "Blank with a bind DN refuses; blank without one means anonymous search.",
      "passwordClear": "Clear the stored password",
      "baseDn": "Base DN",
      "userFilter": "User filter",
      "groupAttribute": "Group attribute",
      "nameAttribute": "Name attribute",
      "save": "Save",
      "saving": "Saving…",
      "toast": {
        "updated": "Directory updated.",
        "created": "Directory created.",
        "failed": "Could not save the directory."
      }
    },
    "ldapMaps": {
      "title": "Group mappings",
      "subtitle": "Directory groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this directory group receive the role at sign-in.",
        "confirm": "Add",
        "group": "Directory group (CN)",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    }
  }
,
  "userGroups": {
    "title": "User Groups",
    "subtitle": "Health-system groups with materialized role grants.",
    "new": "New group",
    "edit": "Edit",
    "delete": "Delete",
    "empty": "No user groups yet.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "columns": {
      "name": "Name",
      "system": "Health system",
      "status": "Status",
      "members": "Members",
      "grants": "Grants",
      "actions": "Actions"
    },
    "toast": {
      "deleted": "Group deleted.",
      "deletedRetracted": "Group deleted; {{count}} grant(s) retracted.",
      "deleteFailed": "Could not delete the group."
    },
    "confirmDelete": {
      "title": "Delete this group?",
      "description": "Memberships and grants go with {{name}}. Grants no other group covers retract immediately."
    },
    "form": {
      "back": "Back to groups",
      "newTitle": "New user group",
      "editTitle": "Edit user group",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "namePlaceholder": "e.g. Night-shift nurses",
      "active": "Active",
      "activeHint": "Deactivating retracts every grant this group confers until reactivated.",
      "save": "Save",
      "saving": "Saving\u2026",
      "cancel": "Cancel",
      "toast": {
        "created": "Group created.",
        "createFailed": "Could not create the group.",
        "saved": "Group saved.",
        "saveFailed": "Could not save the group.",
        "loadFailed": "Could not load the group."
      }
    },
    "members": {
      "title": "Members",
      "subtitle": "The group\u2019s grants apply to every member.",
      "add": "Add member",
      "remove": "Remove",
      "empty": "No members yet.",
      "columns": {
        "username": "Username",
        "fullName": "Full name",
        "actions": "Actions"
      },
      "toast": {
        "added": "Member added.",
        "addFailed": "Could not add the member.",
        "removed": "Member removed.",
        "removeFailed": "Could not remove the member."
      },
      "addDialog": {
        "title": "Add member",
        "description": "The group\u2019s grants apply to the new member immediately.",
        "confirm": "Add",
        "user": "User",
        "userPlaceholder": "Select a user"
      },
      "deleteConfirm": {
        "title": "Remove {{name}}?",
        "description": "Grants no other group covers retract immediately."
      }
    },
    "grants": {
      "title": "Grants",
      "subtitle": "Roles this group confers on its members.",
      "add": "Add grant",
      "remove": "Remove",
      "empty": "No grants yet.",
      "systemWide": "System-wide",
      "columns": {
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "toast": {
        "added": "Grant added.",
        "addFailed": "Could not add the grant.",
        "removed": "Grant removed.",
        "removeFailed": "Could not remove the grant."
      },
      "addDialog": {
        "title": "Add grant",
        "description": "The grant fans out to every member immediately.",
        "confirm": "Add",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (optional)"
      },
      "deleteConfirm": {
        "title": "Remove the {{role}} grant?",
        "description": "Members lose it unless another grant still covers them."
      }
    }
  },
  "fileKey": {
      "title": "License key",
      "subtitle": "File-key licensing for this self-managed installation.",
      "refresh": "Refresh",
      "loadError": "Could not load license status.",
      "status": {
        "valid": "Valid",
        "evaluation": "Evaluation",
        "grace": "Grace period",
        "expired": "Expired",
        "invalid": "Invalid",
        "serving": "Serving requests.",
        "refused": "Refusing requests.",
        "reason": "Reason",
        "evalCountdown": "No license key installed. Evaluation ends in {{count}} days — install a key before then.",
        "evalCapUsage": "Evaluation patients: {{used}} of {{cap}} used. New registrations refuse past the cap \u2014 install a license key to continue.",
        "graceCountdown": "Service continues for {{count}} more hours while this is resolved. Install a valid key before the window closes."
      },
      "fields": {
        "customer": "Customer",
        "format": "Format",
        "purpose": "Purpose",
        "expires": "Expires",
        "maxUsers": "Max users",
        "derivation": "Host binding",
        "features": "Features"
      },
      "format": {
        "flostel": "FLOSTEL (JSON)",
        "vyna": "Legacy VYNA"
      },
      "derivation": {
        "strong": "Strong (hardware-anchored)",
        "weak": "Weak (machine-id only)"
      },
      "hosts": {
        "title": "Bound hosts",
        "subtitle": "Every host computer ID this key covers. HA installs carry one entry per host.",
        "floating": "Floating key — not bound to any host.",
        "covered": "Key covers {{count}} host(s).",
        "thisHost": "This host",
        "notCovered": "This host is NOT covered by the installed key. The key was issued for different host IDs."
      },
      "host": {
        "title": "This host",
        "subtitle": "Send this computer ID to the vendor to receive a bound key. HA installs collect one per host.",
        "copy": "Copy",
        "copied": "Copied",
        "copyFailed": "Copy failed.",
        "strength": "Binding strength",
        "dmi": "DMI product UUID",
        "present": "Present",
        "absent": "Unreadable",
        "machineId": "OS machine ID",
        "why": "Why two IDs?"
      },
      "request": {
        "title": "Request a key",
        "subtitle": "Generate the unsigned request file the vendor signs. This host is always included; add HA members below. Contact and notes go in the email summary only.",
        "customerLabel": "Customer",
        "customerPlaceholder": "e.g. Acme Hospital",
        "maxUsersLabel": "Max users",
        "maxUsersPlaceholder": "Blank = unlimited",
        "contactLabel": "Contact",
        "contactPlaceholder": "Name and email for the vendor",
        "notesLabel": "Notes",
        "notesPlaceholder": "Optional context for the vendor",
        "featuresLabel": "Licensed modules",
        "hostsLabel": "Extra HA hosts",
        "hostsPlaceholder": "One host fingerprint per line, from each member's license page",
        "hostsHint": "This host ({{fp}}) is always included.",
        "generate": "Generate request",
        "invalidMaxUsers": "Max users must be a whole number.",
        "failed": "Request generation failed.",
        "summaryTitle": "Email summary",
        "copySummary": "Copy summary",
        "copiedSummary": "Copied",
        "fileTitle": "Request file",
        "download": "Download request file"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "License key installed.",
        "failed": "Key install failed.",
        "haNote": "HA: repeat on every host, or mount one key file everywhere. Kubernetes Secret mounts are updated in the cluster, not here."
      }
    },
    "orgKey": {
      "title": "Organization license key",
      "subtitle": "Signed module license for health system {{id}}.",
      "back": "Health systems",
      "refresh": "Refresh",
      "loadError": "Could not load organization key status.",
      "status": {
        "valid": "Valid",
        "missing": "Not installed",
        "broken": "Invalid",
        "missingHint": "No key installed. Premium modules (billing, analytics) stay off; clinical care is unaffected.",
        "reason": "Reason"
      },
      "fields": {
        "customer": "Customer",
        "expires": "Expires",
        "maxUsers": "Max users",
        "purpose": "Purpose",
        "installedAt": "Installed",
        "features": "Licensed modules"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "Organization key installed.",
        "failed": "Key install failed.",
        "floatingNote": "Organization keys must be floating — machine binding is meaningless for SaaS."
      },
      "delete": {
        "title": "Remove the key",
        "subtitle": "Premium modules turn off for every facility in this organization. Clinical care is unaffected.",
        "action": "Remove key",
        "confirm": "Yes, remove it",
        "cancel": "Cancel",
        "success": "Organization key removed.",
        "failed": "Key removal failed."
      }
    }
}
